$(document).ready(function() {
"use strict";

$(".button--cookie").click(function () {
  $("#cookie--banner").hide();
});

function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}
if (getCookie('cookies-accepted') == 'yes') {} else {
  setTimeout(function () {
    $("#cookie--banner").addClass("apparition--cookie");
    var CookieDate = new Date();
    CookieDate.setMonth(CookieDate.getMonth() + 12);
    document.cookie = "cookies-accepted=yes; expires=" + CookieDate.toGMTString() + "; path=/";
  }, 3000);
}
'use strict';

$('.faq__q__and__a').on('click', function () {
  var $question = $(this).children('.faq__question');
  if ($question.siblings().attr('aria-hidden') == 'false') {
    $question.siblings().slideToggle(200).attr('aria-hidden', 'true');
    $question.children('span').attr('arrow-open', 'false');
  } else {
    $('.faq__q__and__a').find('.faq__answer[aria-hidden="false"]').not($question).slideToggle(200).attr('aria-hidden', 'true');
    $('.faq__q__and__a').find('.arrow[arrow-open="true"]').attr('arrow-open', 'false');
    $question.siblings().slideToggle(200).attr('aria-hidden', 'false');
    $question.children('span').attr('arrow-open', 'true');
  }
});

$('.sidebar__sections--list-link').on('click', function () {
  var id = $(this).attr('section-id');

  $('html, body').animate({
    scrollTop: $(id).offset().top - 70
  }, 500);
});
"use strict";
'use strict';

$('body').on('click', '.button__action', function (e) {
  e.preventDefault();
  var buttonFor = $(this).attr('for');
  var selector = $(this).attr('open-selector');

  if (selector) {
    $(selector).addClass('opened');
    if (buttonFor == "drawer-filter") {
      $('#page__overlay-filter').addClass('opened');
    } else {
      $('#page__overlay').addClass('opened');
    }
  }

  if (buttonFor == 'modal' && selector) {
    $('#page__overlay').attr('for', 'modal');
  } else if (buttonFor == 'drawer' && selector) {
    $('#page__overlay').attr('for', 'drawer');
    $('#navigation__drawer--header-image').show();
  } else if (buttonFor == 'tooltip' && selector) {
    if (window.matchMedia("(max-width: 767px)").matches) {
      $('#page__overlay').attr('for', 'tooltip');
    }
    $('#page__overlay').attr('for', 'tooltip');
  } else if (buttonFor == 'drawer-cart' && selector) {
    $('#page__overlay').attr('for', 'drawer');
    setTimeout(function () {
      $('#drawer__cart--exta-infos').addClass('opened');
    }, 350);
  } else if (buttonFor == 'accordeon') {
    var isActive = false;
    if ($(this).hasClass('active')) {
      isActive = true;
    }
    if ($(this).hasClass('link--item-button')) {
      $('.link--item-button.active').siblings('.accordeon__list').removeClass('opened').slideToggle('500');
      $('.link--item-button.active').children('.plus__icon').removeClass('opened');
      $('.link--item-button.active').removeClass('active');
    } else if ($(this).hasClass('sub__link--item-button')) {
      $('.sub__link--item-button.active').siblings('.accordeon__list').removeClass('opened').slideToggle('500');
      $('.sub__link--item-button.active').children('.plus__icon').removeClass('opened');
      $('.sub__link--item-button.active').removeClass('active');
    }

    if (isActive == false) {
      $(this).toggleClass('active');
      $(this).children('.plus__icon').toggleClass('opened');
      $(this).siblings('.accordeon__list').addClass('opened').slideToggle('500');
    }
  }
  if (buttonFor == 'select' && selector) {
    $('#page__overlay').attr('for', 'select');
  }
});

// Fermer la modal au clic sur la croix
$('.close').on('click', function (e) {
  e.preventDefault();
  var closeFor = $(this).attr('for');

  $('#page__overlay').removeClass('opened');
  $('#page__overlay').attr('for', '');

  if (closeFor == 'modal') {
    $('.modal').removeClass('opened');
    $('.modal-loader').show();
    $('.modal-has-to-load').hide();
  } else if (closeFor == 'tooltip') {
    $('#tooltip--container-help').removeClass('opened');
  } else if (closeFor == 'drawer') {
    $('.drawer').removeClass('opened');
  } else if (closeFor == 'drawer-filter') {
    $('#filter-collection-drawer').removeClass('opened');
    $('#page__overlay-filter').removeClass('opened');
  } else if (closeFor == 'select') {
    $('.select').removeClass('opened');
  }
});

// Clic en dehors de la'modal'
$('#page__overlay').on('click', function (e) {
  e.preventDefault();
  var overlayFor = $(this).attr('for');

  $(this).removeClass('opened');
  $('#page__overlay').attr('for', '');

  $('.hidden-selecteur-size-mobile--container, .custom-field__existe-aussi-dans-cet-imprime').removeClass('opened');

  if (overlayFor == 'modal') {
    $('.modal').removeClass('opened');
    $('.modal-loader').show();
    $('.modal-has-to-load').hide();
  } else if (overlayFor == 'drawer') {
    $('.drawer').removeClass('opened');
  } else if (overlayFor == 'tooltip') {
    $('.tooltip--container').removeClass('opened');
  } else if (overlayFor == 'select') {
    $('.select').removeClass('opened');
  }
});

// Ajout de la variant lors de la selection + Fermer modal
$('.variant__select').on('click', function (e) {
  //$('#iddeclasse').attr('variant', $(this).attr("value"));
  e.preventDefault();
  $('.select').removeClass('opened');
  var closeFor = $(this).attr('for');
  $('#page__overlay').removeClass('opened');
  $('#page__overlay').attr('for', '');
});

$('#page__overlay--white').on('click', function (e) {
  e.preventDefault();
  $(this).removeClass('opened');
  $('.select__custom--values').hide();
  $('.select__custom--values').removeClass('opened');
});

$('#page__overlay--white-quick-add').on('click', function (e) {
  e.preventDefault();
  $(this).removeClass('opened');
  $('#product-grid-modal .select__custom--values').hide();
  $('#product-grid-modal .select__custom--values').removeClass('opened');
});

$('#page__overlay-filter').on('click', function (e) {
  e.preventDefault();

  $(this).removeClass('opened');
  $('#page__overlay-modal').attr('for', '');
  $('#filter-collection-drawer').removeClass('opened');
});
'use strict';

document.addEventListener('select-changed:carrier', function (event) {
  var carrierId = $('#carrier__select option:selected').text();
  $('.carrier--container').hide();
  $('.carrier--container[carrierId="' + carrierId + '"]').fadeIn(300).css('display', 'flex');
}, false);
'use strict';

window.addEventListener('load', function (event) {
  if (window.location.href.indexOf("categorie") > -1) {
    var msnry = new Masonry('.masonry-container', {
      itemSelector: '.masonry-item',
      columnWidth: '.masonry-sizer',
      percentPosition: true
    });
  }
});
'use strict';

// Clic en dehors de la'modal'
$('#page__overlay').on('click', function (e) {
  e.preventDefault();
  var overlayFor = $(this).attr('for');

  if (overlayFor == 'modal') {
    $('.modal').removeClass('opened');
    $(this).removeClass('opened');
    $('#page__overlay').attr('for', '');
  }
});
"use strict";
'use strict';

var handleSearchBar = function handleSearchBar(searchTriggerId, positionScrolledClass, positionClass, translateYScrolled, translateY) {
  $(searchTriggerId).on('click', function () {
    if ($('.search--container').hasClass(positionScrolledClass) || $('.search--container').hasClass(positionClass)) {
      $('#page__overlay--navigation').removeClass('opened');
      $('.navigation__item--container').removeClass('search--opened');
      $('#navigation--container').removeClass('fixedWhiteNav');
      $('.search--container').removeClass(positionScrolledClass + ' ' + positionClass);
      $('.search--container').css('transform', '');
      $('.searchProduct').val('');
      $(".result-search").html('');
      $(".popular_product").hide();
    } else {
      $('#page__overlay--navigation').addClass('opened');
      $('.navigation__item--container').addClass('search--opened');
      $('#navigation--container').addClass('fixedWhiteNav');
      $('#navigation--container').removeClass('transparent--nav');
      $(".popular_product").show();

      if (window.matchMedia("(max-width: 1150px)").matches) {
        $('#navigation__drawer').removeClass('opened');

        $('.menu').removeClass('change close').addClass('button__action');
        $('#page__overlay').removeClass('opened');
      }

      if ($(document).scrollTop() >= 20) {
        $('.search--container').addClass(positionScrolledClass);
      } else {
        var topPosition = translateY - $(document).scrollTop();
        $('.search--container').addClass(positionClass);
        $('.search--container.' + positionClass + ', .search--container.' + positionScrolledClass).css('transform', 'translateY(' + topPosition + 'px)');
      }
    }
    $('.searchProduct.search--input').focus();
  });

  $(document).on('scroll', function () {
    if ($(document).scrollTop() >= 20) {
      $('.search--container.' + positionClass + ', .search--container.' + positionScrolledClass).css('transform', 'translateY(' + translateYScrolled + 'px)');
    } else {
      var topPosition = translateY - $(document).scrollTop();
      $('.search--container.' + positionClass + ', .search--container.' + positionScrolledClass).css('transform', 'translateY(' + topPosition + 'px)');
    }
  });
};

if (window.matchMedia("(max-width: 767px)").matches) {
  handleSearchBar('#icon-search-mobile', 'opened-mobile-scroll', 'opened-mobile2', 260, 260);
} else if (window.matchMedia("(max-width: 1100px)").matches) {
  handleSearchBar('#icon-search-mobile', 'opened-mobile-scroll', 'opened-mobile', 260, 295);
} else {
  handleSearchBar('#icon-search', 'opened-scroll', 'opened', 270, 305);
}

var handleCloseSearch = function handleCloseSearch() {
  $('.searchProduct').val('');
  $(".result-search").html('');
  $('.search--container').removeClass('opened opened-scroll opened-mobile-scroll opened-mobile opened-mobile2');
  $('.search--container').css('transform', '');
  $('#navigation--container').removeClass('fixedWhiteNav');
  $('#page__overlay--navigation').removeClass('opened');
  $('.navigation__item--container').removeClass('search--opened');
  $('.result-search').css('display', 'none');
  $('.navigation__item--link-megamenu').removeClass('search--active');
};

window.addEventListener("pageshow", function (event) {
  handleCloseSearch();
});

$('.close--search').on('click', function () {
  handleCloseSearch();
});

$(document).on('click', function (e) {
  var container = $(".search--container");
  if ($(e.target).hasClass('search--trigger')) {} else {
    if ((container.hasClass('opened') || container.hasClass('opened-mobile') || container.hasClass('opened-scroll') || container.hasClass('opened-mobile-scroll') || container.hasClass('opened-mobile2')) && !container.is(e.target) && container.has(e.target).length === 0) {
      handleCloseSearch();
    }
  }
});

$(document).on('click', '.global-search', function () {
  //var url = window.location.hostname
  var search = document.getElementsByClassName('searchProduct')[0].value;
  var redirection = "/search?type=product&q=" + search;
  window.location.replace(redirection);
  $('.search--container').removeClass('opened');
});
// }


$(document).on('input', '.search--input', function () {
  if ($(this).attr('search') === 'barre') {
    SearchFunction('searchArticle-barre', 'article', 'result-search-barre');
  } else if ($(this).attr('search') === 'article') {
    SearchFunction('searchArticle', 'article', 'result-search');
  } else if ($(this).attr('search') === 'produit') {
    SearchFunction('searchProduct', 'product', 'result-search');
  }
});

var SearchFunction = function SearchFunction(classInput, typeSearch, classInputResult) {

  var htmlItem = function htmlItem(type, item) {
    var typeImage = "jpg";
    var splitedImage = item[i].image.split('.jpg');
    if (splitedImage.length == 1) {
      splitedImage = item[i].image.split('.png');
      typeImage = "png";
    }
    var image = item[i].image;
    if (splitedImage.length > 1) {
      image = splitedImage[0] + '_500x.' + typeImage + splitedImage[1];
    }

    if (type == "article") {
      return "<div class='one-product'><a class='grid--search flex flex--column justify__content--center' href=" + item[i].url + "><img class='image-product' src=" + image + "><div class='content--container flex flex--column ai--center'><p class='price--grid dark__color'>" + item[i].title + "</p></div></a></div>";
    } else {
      if (item[i].compare_at_price_max == 0.00) {
        var prix = item[i].price.replace('.', ',') + '€';
      } else {
        var prix = item[i].price.replace('.', ',') + "€<span class='reduction line__through '>" + item[i].compare_at_price_max.replace('.', ',') + "€</span>";
      }
      return " <div class='one-product'><a class='grid--search flex flex--column justify__content--center' href=" + item[i].url + "><img class='image-product' src=" + image + "><div class='content--container flex flex--column ai--center'><p class='product__grid--title dark__color'>" + item[i].title + "</p><p class='price subtitle--h2 dark__color fw--700'>" + prix + "</p></div></a></div>";
    }
  };

  var emptyItem = function emptyItem(type) {
    if (type == "article") {
      return "<div class='empty'>Aucun article correspond à votre recherche</div>";
    } else {
      return "<div class='empty'>Aucun produit correspond à votre recherche</div>";
    }
  };

  var q = document.getElementsByClassName(classInput)[0].value;
  var b = '&resources[type]=' + typeSearch;
  var c = '';
  if (q == "") {
    $(".result-search").html('');
    $(".result-search-barre").html('');
  }
  if (typeSearch == 'article') {
    var type = "article";
  } else {
    var type = "product";
    c = '&fields=title,product_type,tag';
    if (q == "") {
      $(".popular_product").show();
    } else {
      $(".popular_product").hide();
    }
  }

  if (q.length >= 3) {
    ga('send', 'event', "Search", "Product", q);
  }

  $.ajax('/search/suggest.json?type=product&q=' + q + b + c, {
    type: 'GET',
    dataType: 'json',
    success: function success(response) {
      var itemsSuggestions = response.resources.results[typeSearch + 's'];
      if (itemsSuggestions.length > 0) {
        var result = "";
        for (i = 0; i < itemsSuggestions.length; i++) {
          if (itemsSuggestions[i].id != 6623214993579 && itemsSuggestions[i].id != 6623216205995) {
            result += htmlItem(type, itemsSuggestions);
          }
        }
        if (type == "product") {
          result = result;
        }
        $('.' + classInputResult).html(result);
        $('.result-search').css('display', 'flex');
        $('.navigation__item--link-megamenu').addClass('search--active');
      } else {
        var emptyProduct = emptyItem(type);
        $('.' + classInputResult).html(emptyProduct);
      }
    }
  });
};
'use strict';

$('body').on('click', '.select__custom--selected-value-container', function (e) {
  var forSelect = $(this).attr('for');
  $('.select__custom--values[for="' + forSelect + '"]').fadeToggle(50);
  $('.select__custom--values[for="' + forSelect + '"]').addClass('opened');
  $('#page__overlay--white').addClass('opened');
  if ($('#product-grid-modal.opened').length > 0) {
    $('#page__overlay--white-quick-add').addClass('opened');
  }
});

$('body').on('click', '.select__custom--value', function (e) {
  var forSelect = $(this).attr('for');
  var value = $(this).attr('value');
  var valueText = $(this).text();
  //est ce quon a modifie un select via quick view
  var quickAdd = $(this).attr('product-grid') || "false";

  $('.select__custom--value[for="' + forSelect + '"]').removeClass('is__active');
  $(this).addClass('is__active');

  $('.select__custom--selected-value[name="' + forSelect + '"]').text(valueText);
  $('.select__hidden[for="' + forSelect + '"]').val(value).trigger('change');
  $('.select__custom--values').hide();
  $('.select__custom--values').removeClass('opened');
  $('#page__overlay--white').removeClass('opened');
  $('#page__overlay--white-quick-add').removeClass('opened');
  document.dispatchEvent(new CustomEvent('select-changed:' + forSelect, { 'detail': { quickAdd: quickAdd } }));
});

document.addEventListener('select-changed:sort--by', function (elem) {}, false);

// Sort
Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
$('.select__hidden[for="sort--by"]').bind('change', function () {
  Shopify.queryParams.sort_by = $(this).val();
  location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
});
'use strict';

// Filters
$('body').on('click', '.reinitialize__filters', function () {
  window.collection.currentFilters = [];
  $('.reinitialize__filters').hide();
  $('.filter__item--mini').remove();
  $('.filter__button').removeClass('is__active');
  var filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + '?sort_by=' + window.collection.sortBy;
  if (history.replaceState) {
    window.history.replaceState({ path: filteredUrl }, '', filteredUrl);
  }
  if (window.collection.drop == true) {
    $.ajax({
      type: 'GET',
      url: filteredUrl + '&view=filtered-drop',
      success: function success(content) {
        var count = parseInt(content.substring(0, 4));
        $('.filter-count').text(count);
        $('#collection__list--container').remove();
        $('#collection__page--desktop').append(content.substring(4));
      },
      error: function error(_error) {
      }
    });
  } else if (window.collection.sansPastille == true) {
    $.ajax({
      type: 'GET',
      url: filteredUrl + '&view=filtered-without-pastilles',
      success: function success(content) {
        var count = parseInt(content.substring(0, 4));
        $('.filter-count').text(count);
        $('#collection__list-without-pastilles--container, .collection-remove-without-pastilles--container').remove();
        $('.without-pastilles').append(content.substring(4));
      },
      error: function error(_error2) {
      }
    });
  } else {
    $.ajax({
      type: 'GET',
      url: filteredUrl + '&view=filtered',
      success: function success(content) {
        var count = parseInt(content.substring(0, 4));
        $('.filter-count').text(count);
        $('#collection__list--container').remove();
        $('#collection__page--desktop').append(content.substring(4));
      },
      error: function error(_error3) {
      }
    });
  }
});

$('body').on('click', '.filter__item--mini', function () {
  var filter_value = $(this).attr('filter-value-handle');
  $('.filter__item--mini[filter-value-handle=' + filter_value + ']').remove();
  $('.filter__button[filter-value-handle=' + filter_value + ']')[0].click();
});

$('body').on('click', '.filter__button', function () {
  var mini__filter = window.collection.miniFilter;
  var filter_value = $(this).attr('filter-value-handle'),
      filteredUrl = '';
  var filtersList = window.collection.currentFilters;

  if ($(this).hasClass('is__active')) {
    $('.filter__button[filter-value-handle=' + filter_value + ']').removeClass('is__active');

    filtersList.splice(filtersList.indexOf(filter_value), 1);

    window.collection.currentFilters = filtersList;
    window.collection.currentFilters.sort();

    $('.filter__item--mini[filter-value-handle=' + filter_value + ']').remove();
  } else {
    // Supprime les tags du meme groupe deja actifs
    var group = filter_value.split('_')[0];
    $('.filter__button[filter-group-handle="' + group + '"]').removeClass('is__active');
    $('.filter__item--mini[filter-group-handle="' + group + '"]').remove();
    $('.filter__button[filter-value-handle=' + filter_value + ']').addClass('is__active');
    for (var i = 0; i < filtersList.length; i++) {
      if (filtersList[i].indexOf(group) > -1) {
        filtersList.splice(i, 1);
      }
    }

    window.collection.currentFilters = filtersList;
    window.collection.currentFilters.push(filter_value);
    window.collection.currentFilters.sort();

    $('.filter__values--list').append('<li class="filter__item--mini body--text--footer" filter-value-handle="' + filter_value + '" filter-group-handle="' + group + '"><span>' + $(this).attr('filter-group') + ': ' + $(this).attr('filter-value') + '</span><span class="close close__filter"></span></li>');
  }

  if (window.collection.currentFilters.length > 0) {
    $('.reinitialize__filters').show();
    filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + '/' + window.collection.currentFilters.join('+') + '?sort_by=' + window.collection.sortBy;
  } else {
    $('.reinitialize__filters').hide();
    filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + '?sort_by=' + window.collection.sortBy;
  }

  if (history.replaceState) {
    window.history.replaceState({ path: filteredUrl }, '', filteredUrl);
  }

  if (window.collection.drop == true) {
    $.ajax({
      type: 'GET',
      url: filteredUrl + '&view=filtered-drop',
      success: function success(content) {
        var count = parseInt(content.substring(0, 4));
        $('.filter-count').text(count);
        $('#collection__list--container').remove();
        $('#collection__page--desktop').append(content.substring(4));
      },
      error: function error(_error4) {
      }
    });
  } else if (window.collection.sansPastille == true) {
    $.ajax({
      type: 'GET',
      url: filteredUrl + '&view=filtered-without-pastilles',
      success: function success(content) {
        var count = parseInt(content.substring(0, 4));
        $('.filter-count').text(count);
        $('#collection__list-without-pastilles--container, .collection-remove-without-pastilles--container').remove();
        $('.without-pastilles').append(content.substring(4));
      },
      error: function error(_error5) {
      }
    });
  } else {
    $.ajax({
      type: 'GET',
      url: filteredUrl + '&view=filtered',
      success: function success(content) {
        var count = parseInt(content.substring(0, 4));
        $('.filter-count').text(count);
        $('#collection__list--container').remove();
        $('#collection__page--desktop').append(content.substring(4));
      },
      error: function error(_error6) {
      }
    });
  }
});

// mobile
$('.action--button-validate').on('click', function (e) {
  e.preventDefault();
  $('#navigation__drawer--header .close').click();
});
$('.action--button-close').on('click', function (e) {
  e.preventDefault();
  $('#navigation__drawer--header .close').click();
});

$('.filter__group--title').on('click', function () {
  $(this).children('plus__icon').toggleClass('opened');
  $(this).siblings('.filter__group--item-list').slideToggle(300);
  $(this).toggleClass('opened');
});

if (window.location.href.indexOf("/collections/") > -1) {
  var printUrl = function printUrl(list) {
    var filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + "?";
    for (var filter in list) {
      filteredUrl += list[filter].type + "=" + list[filter].value + "&";
    }

    //var sortBy = $('#sort__by--container .select__custom--value.is__active').attr('value')
    //var filterSortBy = 'sort_by=' + sortBy

    var filterSortBy = 'sort_by=manual';

    var pageUrl = '';
    /*if (window.location.href.indexOf('page=') > -1){
      var url_string = window.location.href
      var url = new URL(url_string);
      var numberPage = url.searchParams.get("page");
      pageUrl = "&page=" + numberPage
     }*/

    var finalUrl = filteredUrl + filterSortBy + pageUrl;

    if (history.replaceState) {
      window.history.replaceState({ path: finalUrl }, '', finalUrl);
    }

    if (window.collection.drop == true) {
      $.ajax({
        type: 'GET',
        url: finalUrl + '&view=filtered-drop',
        success: function success(content) {
          var count = parseInt(content.substring(0, 4));
          $('.filter-count').text(count);
          $('#collection__list--container').remove();
          $('#collection__page--desktop').append(content.substring(4));

          clearFilter();
        },
        error: function error(_error7) {
        }
      });
    } else if (window.collection.sansPastille == true) {
      $.ajax({
        type: 'GET',
        url: filteredUrl + '&view=filtered-without-pastilles',
        success: function success(content) {
          var count = parseInt(content.substring(0, 4));
          $('.filter-count').text(count);
          $('#collection__list-without-pastilles--container, .collection-remove-without-pastilles--container').remove();
          $('.without-pastilles').append(content.substring(4));
        },
        error: function error(_error8) {
        }
      });
    } else {
      $.ajax({
        type: 'GET',
        url: finalUrl + '&view=filtered',
        success: function success(content) {
          var count = parseInt(content.substring(0, 4));
          $('.filter-count').text(count);
          $('#collection__list--container, .collection-remove--container').remove();
          $('#collection__page--desktop').append(content.substring(4));

          clearFilter();
        },
        error: function error(_error9) {
        }
      });
    }
  };

  var collectionFilter = {};
  if ($('[collection-filter]').html()) {
    collectionFilter = JSON.parse($('[collection-filter]').html());
  }

  //Range slider price
  var $range = $(".js-range-slider"),
      $from = $(".from"),
      $to = $(".to"),
      range,
      min = $range.data('min'),
      max = $range.data('max'),
      from,
      to;

  var updateValues = function updateValues() {
    $from.prop("value", from);
    $to.prop("value", to);

    dataFilter = boucleFilter();
    printUrl(dataFilter);
  };

  var updateFilter = function updateFilter() {
    var maxRange = collectionFilter.filterMaxRange / 100;
    if (from == '0' && to == maxRange) {
      $('.active-filters__remove-filter[filtername="filter-price"]').hide();
    } else {
      $('.active-filters__remove-filter[filtername="filter-price"]').show();
      $('.min-value-filter').text(from + "€");
      $('.max-value-filter').text(to + "€");
    }
  };

  $range.ionRangeSlider({
    onChange: function onChange(data) {
      from = data.from;
      to = data.to;
      updateValues();
      updateFilter();
      $('.irs-from, .irs-to').append(' €');
    }
  });

  $(window).bind("load", function () {
    $('.irs-from, .irs-to').append(' €');
  });

  range = $range.data("ionRangeSlider");
  var updateRange = function updateRange() {
    range.update({
      from: from,
      to: to
    });
  };

  $from.on("input", function () {
    from = +$(this).prop("value");
    if (from < min) {
      from = min;
    }
    if (from > to) {
      from = to;
    }
    updateValues();
    updateRange();
    updateFilter();
  });

  $to.on("input", function () {
    to = +$(this).prop("value");
    if (to > max) {
      to = max;
    }
    if (to < from) {
      to = from;
    }
    updateValues();
    updateRange();
    updateFilter();
  });

  $(document).ready(function () {
    if (collectionFilter.filterMaxValue != '') {
      to = collectionFilter.filterMaxValue / 100;
    }
    if (collectionFilter.filterMinValue != '') {
      from = collectionFilter.filterMinValue / 100;
    }
    //updateValues();
    updateRange();
  });

  var clearFilter = function clearFilter() {
    var url = window.location.href;
    var matches = url.match(/[a-z\d]+=[a-z\d]+/gi);
    var count = matches ? matches.length : 0;
    if (window.location.search.indexOf('page=') > -1) {
      count = count - 1;
    }
    /*if(count > 1 ){
      $('.active-filters__clear').show()
    } else {
      $('.active-filters__clear').hide()
    }*/
  };

  var countFilterActive = 0;

  $(document).ready(function () {
    clearFilter();
    $('.filter-group-display__list-item').each(function (index) {
      var containerCheck = $(this).find('.filter--container');
      if (containerCheck.hasClass('checked')) {
        countFilterActive = countFilterActive + 1;
      }
      if (countFilterActive > 0) {
        $('.count-filter--container').removeClass('hide');
        $('.count-filter-active').text(countFilterActive);
      }
    });
  });

  var dataFilter = [];

  var boucleFilter = function boucleFilter() {
    var array = [];
    $(".filter-group-display__list").each(function () {
      var containerFilter = $(this).children('.filter-group-display__list-item');

      var checkbox = containerFilter.children('.filter--container').children('.checkbox-filter--container');
      var value = "";
      var name = checkbox.attr('name');
      var compteurCheck = 0;

      for (var i = 1; i <= containerFilter.length; i++) {

        var loopCheckbox = containerFilter.children('.filter--container').children('.checkbox-' + i);
        if (loopCheckbox.hasClass('checked')) {
          if (name == "filter.v.option.taille") {
            if ($(".checkbox-filter--container.checkbox-1[name='filter.v.availability']").hasClass('checked')) {} else {
              $(".checkbox-filter--container.checkbox-1[name='filter.v.availability']").click();
            }
          }

          compteurCheck += 1;

          compteurCheck == 1 ? value = loopCheckbox.attr('value') : value = value + ',' + loopCheckbox.attr('value');
        }
      }

      var counterChecked = 0;
      $(".taille-filter").each(function () {
        var containerFilter = $(this).children('.filter--container');

        for (var _i = 1; _i <= containerFilter.length; _i++) {
          if (containerFilter.hasClass('checked')) {
            counterChecked += 1;
          }
        }
      });
      if (counterChecked == 0) {
        if ($(".checkbox-filter--container.checkbox-1[name='filter.v.availability']").hasClass('checked')) {
          $(".checkbox-filter--container.checkbox-1[name='filter.v.availability']").click();
        }
      }

      compteurCheck > 0 ? array.push({ type: name, value: value }) : null;
    });

    var nameFilterLow = $('#lowPriceFilter').attr('name');
    var valueLow = $('#lowPriceFilter').val();

    var nameFilterHigh = $('#highPriceFilter').attr('name');
    var valueHigh = $('#highPriceFilter').val();
    var maxValueHigh = $('#highPriceFilter').attr('max');

    if (parseInt(valueLow) > 0) {
      array.push({ type: nameFilterLow, value: valueLow });
    }

    if (parseInt(valueHigh) < parseInt(maxValueHigh)) {
      array.push({ type: nameFilterHigh, value: valueHigh });
    }

    return array;
  };

  if (window.location.href.indexOf("collections") > -1) {

    dataFilter = boucleFilter();
  }

  $('body').on('click', '.active-filters__clear', function () {
    var link = $(this).attr('link');
    $('.filter--container, .checkbox-filter--container').removeClass('checked');
    $('#lowPriceFilter').attr('value', 0);
    var maxRangeValue = collectionFilter.filterMaxRange / 100;

    $('#highPriceFilter').attr('value', maxRangeValue);
    $('#highPriceFilter').val(maxRangeValue);
    to = maxRangeValue;
    from = 0;
    updateValues();
    updateRange();
    $('.irs-from, .irs-to').append(' €');
    window.history.replaceState({ path: link }, '', link);

    countFilterActive = 0;
    $('.count-filter--container').addClass('hide');

    $.ajax({
      type: 'GET',
      url: link + '&view=filtered',
      success: function success(content) {
        var count = parseInt(content.substring(0, 4));
        $('.filter-count').text(count);
        $('#collection__list--container, .collection-remove--container').remove();
        $('#collection__page--desktop').append(content.substring(4));

        clearFilter();
      },
      error: function error(_error10) {
      }
    });
  });

  $('body').on('click', '.filter--container', function () {
    var filterName = $(this).find('.checkbox-filter--container').attr('filtername');
    var filterTaille = $(this).find('.checkbox-filter--container').attr('name');
    if ($(this).find('.checkbox-filter--container').hasClass('checked')) {
      if (filterTaille == 'filter.v.option.taille') {} else if (filterTaille == 'filter.p.m.my_fields.imprim_s') {
        $(this).siblings('color-name').css('color', '#545454');
      } else {
        countFilterActive = countFilterActive - 1;
      }
      $('.active-filters__remove-filter[filtername=' + filterName + ']').remove();
    } else {
      countFilterActive = countFilterActive + 1;
      if (filterName == 'Disponibilité-Enstock') {
        var filterValue = 'En stock';
      } else if (filterTaille == 'filter.v.option.taille') {
        countFilterActive = countFilterActive - 1;
        $('.taille--container').removeClass('checked');
        $('.taille--container').children('.checkbox-filter--container').removeClass('checked');
      } else {
        var filterValue = $(this).find('.checkbox-filter--container').attr('value');
      }
      $('.active-filters').append('\n    <a class="active-filters__remove-filter cursor--pointer" filtername="' + filterName + '">\n        ' + filterValue + ' X\n    </a>\n  ');
    }

    if (countFilterActive > 0) {
      $('.count-filter--container').removeClass('hide');
      $('.count-filter-active').text(countFilterActive);
    } else {
      $('.count-filter--container').addClass('hide');
    }

    var checkboxContainer = $(this).children('.checkbox-filter--container');
    checkboxContainer.hasClass('checked') ? checkboxContainer.removeClass('checked') : checkboxContainer.addClass('checked');
    $(this).hasClass('checked') ? $(this).removeClass('checked') : $(this).addClass('checked');

    dataFilter = boucleFilter();
    printUrl(dataFilter);
  });

  $('body').on('click', '.active-filters__remove-filter', function () {
    var filterName = $(this).attr('filtername');
    if (filterName == "filter-price") {
      $('.active-filters__remove-filter[filtername="filter-price"]').hide();
      $('#lowPriceFilter').attr('value', 0);
      var maxRangeValue = collectionFilter.filterMaxRange / 100;

      $('#highPriceFilter').attr('value', maxRangeValue);
      $('#highPriceFilter').val(maxRangeValue);
      to = maxRangeValue;
      from = 0;
      updateValues();
      updateRange();
    } else {
      $(this).remove();
      $('.checkbox-filter--container[filtername=' + filterName + ']').removeClass('checked');
    }
    dataFilter = boucleFilter();
    printUrl(dataFilter);
  });

  var countEuro = 1;
  $('body').on('click', '.filter-group-summary', function () {

    if ($(this).hasClass('checked')) {
      $(this).removeClass('checked');
      $(this).siblings('.filter-group-display').slideToggle(200);
      $(this).children('.plus__icon').removeClass('opened');
    } else {
      $(this).addClass('checked');
      $(this).siblings('.filter-group-display').slideToggle(200);
      $(this).children('.plus__icon').addClass('opened');

      /*setTimeout(function(){
        if (countEuro == 1){
          countEuro = countEuro + 1;
          $('.irs-from, .irs-to').append(' €')
        }
      }, 500);*/
    }
  });
}

var scrollNavDrawer = function scrollNavDrawer() {
  if ($(document).scrollTop() > 20) {
    var navbarFilterDesktop = 70;
    var navbarFilterMobile = 0;
  } else {
    var navbarFilterDesktop = 105;
    var navbarFilterMobile = 0;
  }

  if (window.matchMedia("(max-width: 1000px)").matches) {
    $('#filter-collection-drawer').css('height', window.innerHeight - navbarFilterMobile);
    $('#filter-collection-drawer').css('top', navbarFilterMobile + 'px');
  } else {
    $('#filter-collection-drawer').css('height', window.innerHeight - navbarFilterDesktop);
    $('#filter-collection-drawer').css('top', navbarFilterDesktop + 'px');
  }

  var heightContainerFilter = $('#filter-collection-drawer').height();
  var heightHeaderFilter = $('.header-filter--container').outerHeight(true);
  var stickyBoutonFilter = $('.sticky-filter--container').outerHeight(true);
  $('.filter-form').css('max-height', heightContainerFilter - heightHeaderFilter - stickyBoutonFilter);
  $('.filter-form').css('height', heightContainerFilter - heightHeaderFilter - stickyBoutonFilter);
};

// Gestion de la hauteur du drawer sur mobile
// a utiliser si le drawer ne fait pas 100% de l'ecran
scrollNavDrawer();

$(document).on('scroll', function () {
  scrollNavDrawer();
});

$('#navigation--container').mouseover(function () {
  if ($('#filter-collection-drawer').hasClass('opened')) {
    $('#filter-collection-drawer, #page__overlay-filter').removeClass('opened');
  }
});
/*

if (window.matchMedia("(max-width: 767px)").matches) {
  $('.filter-group-summary').addClass('checked')
  $('.filter-group-summary .plus__icon').addClass('opened')
  $('.filter-group-display').css('display', 'block')
}*/

$('.see-more-print').on('click', function () {
  $('.imprimes').css('overflow-x', 'initial').css('flex-wrap', 'wrap');
  $(this).hide();
  $('.see-less-print').show();
});

$('.see-less-print').on('click', function () {
  $('.imprimes').css('overflow-x', 'scroll').css('flex-wrap', 'initial');
  $(this).hide();
  $('.see-more-print').show();
});

$('.see-more-taille').on('click', function () {
  $('.tailles').css('overflow-x', 'initial').css('flex-wrap', 'wrap');
  $(this).hide();
  $('.see-less-taille').show();
});

$('.see-less-taille').on('click', function () {
  $('.tailles').css('overflow-x', 'scroll').css('flex-wrap', 'initial');
  $(this).hide();
  $('.see-more-taille').show();
});

$('.see-more-type').on('click', function () {
  $('.type').css('overflow-x', 'initial').css('flex-wrap', 'wrap');
  $(this).hide();
  $('.see-less-type').show();
});

$('.see-less-type').on('click', function () {
  $('.type').css('overflow-x', 'scroll').css('flex-wrap', 'initial');
  $(this).hide();
  $('.see-more-type').show();
});

$('.see-more-matiere').on('click', function () {
  $('.matiere').css('overflow-x', 'initial').css('flex-wrap', 'wrap');
  $(this).hide();
  $('.see-less-matiere').show();
});

$('.see-less-matiere').on('click', function () {
  $('.matiere').css('overflow-x', 'scroll').css('flex-wrap', 'initial');
  $(this).hide();
  $('.see-more-matiere').show();
});

$('.see-more-label').on('click', function () {
  $('.label').css('overflow-x', 'initial').css('flex-wrap', 'wrap');
  $(this).hide();
  $('.see-less-label').show();
});

$('.see-less-label').on('click', function () {
  $('.label').css('overflow-x', 'scroll').css('flex-wrap', 'initial');
  $(this).hide();
  $('.see-more-label').show();
});
'use strict';

$('.product__item__link--container').on('click', function (e) {
  e.preventDefault();
  if ($(e.target).is('.grid__arrow--container, .grid__arrow')) {
    sliderProductgrid(e);
  } else if ($(e.target).is('.BIS_trigger')) {} else {
    window.location = this.href;
  }
});

function sliderProductgrid(e) {
  var productHandle = $(e.target).is('.grid__arrow--container') ? $(e.target).attr('handle') : $(e.target).parent('.grid__arrow--container').attr('handle');
  var sliderNumber = $(e.target).is('.grid__arrow--container') ? $(e.target).attr('slider-number') : $(e.target).parent('.grid__arrow--container').attr('slider-number');
  var imageRank = $(e.target).is('.grid__arrow--container') ? $(e.target).attr('rank-image') : $(e.target).parent('.grid__arrow--container').attr('rank-image');
  var action = $(e.target).is('.grid__arrow--container') ? $(e.target).attr('action') : $(e.target).parent('.grid__arrow--container').attr('action');

  // // TO COMPLETE - BEGIN
  // var img = $(`.product__item__image[img-handle=${productHandle}]`);
  // img.on('load', imgeLoaded(productHandle));
  //         $(`.product__item__image[img-handle=${productHandle}]`).css('opacity', '0');
  // // TO COMPLETE - END

  var imgNext = $(e.target).is('.grid__arrow--container') ? $(e.target).attr('next-img') : $(e.target).parent('.grid__arrow--container').attr('next-img');
  var imgPrev = $(e.target).is('.grid__arrow--container') ? $(e.target).attr('prev-img') : $(e.target).parent('.grid__arrow--container').attr('prev-img');

  if (window.gridSlider.productHandle != productHandle) {
    window.gridSlider.productHandle = productHandle;
    window.gridSlider.imgRank = parseInt(imageRank);
    if (imageRank == 0) {
      if (action == "prev") {
        $('.product__item__image[img-handle=' + productHandle + '][slider-number=' + sliderNumber + ']').attr('srcset', '');
        $('.product__item__image[img-handle=' + productHandle + '][slider-number=' + sliderNumber + ']').removeClass('lazyload');
        $('.product__item__image[img-handle=' + productHandle + '][slider-number=' + sliderNumber + ']').attr('src', imgPrev);
      } else {
        $('.product__item__image[img-handle=' + productHandle + '][slider-number=' + sliderNumber + ']').attr('srcset', '');
        $('.product__item__image[img-handle=' + productHandle + '][slider-number=' + sliderNumber + ']').removeClass('lazyload');
        $('.product__item__image[img-handle=' + productHandle + '][slider-number=' + sliderNumber + ']').attr('src', imgNext);
      }
    }

    $.ajax({
      type: 'GET',
      url: '/products/' + productHandle + '.js',
      dataType: 'json',
      success: function success(data) {
        var imagesArray = [];
        for (var i = 0; i < data.images.length; i++) {
          if (data.images[i].indexOf('--paysage') == -1 && data.images[i].indexOf('videoproduct') == -1) {
            imagesArray.push(resizeImage(data.images[i], '_550x'));
          }
        }
        window.gridSlider.images = imagesArray;
        window.gridSlider.imagesSize = imagesArray.length;
        // if (imageRank != 0) {
        //   changeImage();
        // } else {
        //   if (action == "prev") {
        //     window.gridSlider.imgRank = rankCalculator(window.gridSlider.imgRank, window.gridSlider.imagesSize, -1)
        //   } else {
        //     window.gridSlider.imgRank = rankCalculator(window.gridSlider.imgRank, window.gridSlider.imagesSize, 1)
        //   }
        //   $(`.grid__arrow--container[handle=${productHandle}]`).attr('rank-image', window.gridSlider.imgRank)
        // }
        changeImage();

        for (var i = 1; i < imagesArray.length; i++) {
          var img = new Image();
          img.src = imagesArray[i];
        }
      }
    });
  } else {
    changeImage();
  }

  // // TO COMPLETE - BEGIN
  // function imgeLoaded(productHandle) {
  //   setTimeout(function(){
  //     $(`.product__item__image[img-handle=${productHandle}]`).css('opacity', '1');
  //   }, 300);
  // }
  // // TO COMPLETE - END

  function resizeImage(url, param) {
    if (url.indexOf('.png') > -1) {
      var splited = url.split('.png');
      url = '' + splited[0] + param + '.png' + splited[1];
      return url;
    } else if (url.indexOf('.jpg') > -1) {
      var splited = url.split('.jpg');
      url = '' + splited[0] + param + '.jpg' + splited[1];
      return url;
    } else if (url.indexOf('.jpeg') > -1) {
      var splited = url.split('.jpeg');
      url = '' + splited[0] + param + '.jpeg' + splited[1];
      return url;
    } else if (url.indexOf('.webp') > -1) {
      var splited = url.split('.webp');
      url = '' + splited[0] + param + '.webp' + splited[1];
      return url;
  }
}

  function changeImage() {
    if (action == "prev") {
      window.gridSlider.imgRank = rankCalculator(window.gridSlider.imgRank, window.gridSlider.imagesSize, -1);
    } else {
      window.gridSlider.imgRank = rankCalculator(window.gridSlider.imgRank, window.gridSlider.imagesSize, 1);
    }

    $('.product__item__image--source[img-handle=' + productHandle + '][slider-number=' + sliderNumber + ']').attr('srcset', '');
    $('.product__item__image[img-handle=' + productHandle + '][slider-number=' + sliderNumber + ']').removeClass('lazyload');

    $('.product__item__image[img-handle=' + productHandle + '][slider-number=' + sliderNumber + ']').attr('src', window.gridSlider.images[window.gridSlider.imgRank]);
    $('.grid__arrow--container[handle=' + productHandle + '][slider-number=' + sliderNumber + ']').attr('rank-image', window.gridSlider.imgRank);
  }

  function rankCalculator(rank, size, adjustment) {
    if (rank == 0 && adjustment == -1) {
      return size - 1;
    } else if (rank == size - 1 && adjustment == 1) {
      return 0;
    } else {
      return rank + adjustment;
    }
  }
}
'use strict';

//footer
$(window).on('resize', function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    $('#sidebar-accordion-footer .extended-submenu').hide();
  }
});

$(window).bind("pageshow", function (event) {
  $(".loader--button").hide();
  $(".wording--button").show();
});

// Custom soi
$('.sound--action').on('click', function () {
  var state = $(this).attr('action');
  var vid = $('.video--custom');
  $('.sound--action').toggleClass('is__visible');
  state == "mute" ? vid.prop('muted', false) : vid.prop('muted', true);
});

$('.video--custom').on('click', function () {
  var state = $(this).prop('muted');
  $('.sound--action').toggleClass('is__visible');
  if (state == true) {
    $(this).prop('muted', false);
  } else {
    $(this).prop('muted', true);
  }
});

// scroll

$(document).on('scroll', function () {
  if ($('.video--defer').length == 1) {
    var printStoriesPos = $('.video--defer').offset().top - 350;

    if ($(document).scrollTop() > printStoriesPos) {
      if ($('#video--home').length == 1) {
        $('#video--home').get(0).load();
      }

      $('.video--defer').get(0).play();
    }
    if ($(document).scrollTop() > 35) {
      $('.result-search').css('height', 'height: calc(100vh - 190px);');
    } else {
      $('.result-search').css('height', 'height: calc(100vh - 155px);');
    }
  }
});

function deferSrcImages(className) {
  var imgDefer = document.getElementsByClassName(className);
  for (var i = 0; i < imgDefer.length; i++) {
    if (imgDefer[i].getAttribute('defer-src')) {
      imgDefer[i].setAttribute('src', imgDefer[i].getAttribute('defer-src'));
    }
  }
}

window.onload = function () {
  deferSrcImages('product__item__image');
  deferSrcImages('source--src');
  var video = document.getElementById("video-slider-product");
  if (video) {
    video.load();
    video.play();
  }
};

if (window.location.href.indexOf("/products/") > -1) {
  $(document).ready(function () {
    for (var i = 1; i <= 3; i++) {
      jQuery.getJSON(window.Shopify.routes.root + ('products/' + window.cross['product' + i] + '.js'), function (product) {

        var price = product.price / 100;
        var priceFinal = price.toFixed(2) + "€";

        var compare = product.compare_at_price / 100;
        var compareFinal = compare.toFixed(2) + "€";

        var one_size = false;
        if (product.variants[0].option1 == 'TU') {
          one_size = true;
        }

        var list = '';
        var first_variant_available;
        for (var i = 0; i < product.variants.length; i++) {
          list = list + ' <li class="bulle__custom--value-look flex ' + (product.variants[i].available == true ? '' : 'out__of__stock') + ' body__text--breadcrumb dark__color" value="' + product.variants[i].option1 + '" variant-available="' + product.variants[i].available + '" variant-id="' + product.variants[i].id + '" product-id="' + product.id + '" for="product__option--1" sku="' + product.variants[i].sku + '">' + product.variants[i].option1 + ' ' + (product.variants[i].available == true ? '' : '- épuisé') + '</li>';
        }
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].available == true) {
            first_variant_available = product.variants[i];
            break;
          }
        }

        var priceVariant = first_variant_available / 100;

        $('#produits__du__look--container .swiper-wrapper').append('\n            <div class="swiper-slide">\n            <div class="product__item--container product__item--look-container">\n              <div class="position__relative product__item__image--container background__light__color" >\n                <a class="product__item__link--container width--100" href="' + product.url + '" style="z-index: 2;">\n                  <img class="product__item__image margin__auto width--100 ' + (product.available == false ? 'sold__out' : '') + '" defer-src="' + product.images[0] + '">\n                </a>\n                <!--' + (product.available == false ? '\n                  <button class="BIS_trigger BIS_trigger--product-grid button__plain--primary__color--light text__uppercase text__center main__title--h3 fw--500 dark__color margin__auto margin__vertical--20 margin__bottom--none" data-product-data=\'{{ product | json | escape }}\'>S\'inscrire \xE0 l\'alerte</button>\n                ' : '') + '-->\n              </div>\n\n\n              <div class="product__item__content--container">\n                <div class="padding__horizontal--30 product__item__content--text">\n                  <div class="flex flex__direction--row align__items--flex-end">\n                    <p class="product__grid--title title-product">' + product.title + '</p>\n                    <span class="margin__horizontal--10" style="margin-bottom: 2px;">-</span>\n                    <p class="product__grid--price flex flex__direction--row price-product"><!--{{ first_variant.price | money }}-->\n                      ' + priceFinal + '\n                      ' + (compare != 0 ? '<span class="product__grid--price-compare" style="margin-left: 10px;">' + compareFinal + '</span>' : '') + '\n                    </p>\n                  </div>\n\n                  <div id="options__look--container" class="swiper-no-swiping">\n                    <div class="select__cases--container  position__relative" >\n                      <div class="size-visible--container cursor--pointer padding__vertical--15">\n                        ' + (one_size == true ? '<p class="flex body__text--breadcrumb">Taille unique</p>' : '<p class="size-visible flex body__text--breadcrumb' + (product.available == false ? 'out__of__stock' : '') + '" product-id="' + product.id + '">Choisir ma taille</p>') + '\n                        ' + (one_size == false ? '<svg class="icon--svg icon--select-arrow" role="presentation" viewBox="0 0 19 12"><polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline></svg>' : '') + '\n                      </div> \n                      ' + (one_size == false ? '\n                        <ul class="select__cases--list size-hidden--container flex flex__direction--column justify__content--flex-start position__absolute width--100" style="display: none;">\n                          ' + list + '\n                        </ul>' : '') + '\n                    </div>\n                  </div>\n                </div>\n              </div>\n\n              <button class="swiper-no-swiping margin__horizontal__unit--0-5 add__to__cart--look button__plain--black text__center body__text--breadcrumb  white fw--700 margin__left--none width--100 product-look--button " variant-id="' + (one_size == true ? '' + first_variant_available.id : '') + '" product-price="' + priceVariant + '" variant-available=' + (first_variant_available.available == true ? true : false) + ' button-type="product" product-id="' + product.id + '" add-to-cart-lookbook="true" product-name="' + product.title + '" product-sku="' + first_variant_available.sku + '">\n              ' + (first_variant_available.available == true ? '<span class="text__center body__text--breadcrumb white text__uppercase wording--cart">Ajouter</span><span class="loader--button"></span>' : '<span class="text__center body__text--breadcrumb white text__uppercase">Rupture de stock</span>') + '\n              </button>\n            </div>\n            </div>\n          ');

        setTimeout(function () {
          var swiperLook = new Swiper('#produits__du__look--container.slider--desktop', {
            direction: 'horizontal',
            loop: true,
            slidesPerView: 2,
            spaceBetween: 20,
            lazy: false,
            noSwiping: true,
            navigation: {
              nextEl: '#swiper-next-look',
              prevEl: '#swiper-prev-look'
            },
            breakpoints: {
              750: {
                spaceBetween: 10,
                autoplay: {
                  delay: 2500,
                  disableOnInteraction: false
                }
              }
            }
          });
        }, 1000);
      });
    }
  });
}
'use strict';

$('#go-top').on('click', function () {
  $('html, body').animate({
    scrollTop: 0
  }, 500);
});

if ($(document).scrollTop() > 20) {
  $('#go-top').show();
  $('#cart__validate--container').css('z-index', 99);
} else {
  $('#go-top').hide();
  $('#cart__validate--container').css('z-index', 1);
}

$(document).on('scroll', function () {
  if ($(document).scrollTop() > 20) {
    $('#go-top').show();
    $('#cart__validate--container').css('z-index', 99);
  } else {
    $('#go-top').hide();
    $('#cart__validate--container').css('z-index', 1);
  }
});
'use strict';

var displayPrice = function displayPrice(price) {
  return price / 100 + '€';
};
'use strict';

$('#newsletter--homepage, #newsletter--blog').submit(function (e) {
  e.preventDefault();
  var index = $(this).attr('form-index');
  var email = $('.email--newsletter[form-index="' + index + '"]').val().toLowerCase();
  var fields = "$source,$email,$consent";
  var formData = {
    "email": email,
    "g": $('.list--newsletter-new[form-index="' + index + '"]').val(),
    "$consent": "email",
    "$source": $('.newsletter-form[form-index="' + index + '"]').attr('source'),
    "$fields": fields
  };

  $.ajax({
    type: "POST",
    url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
    data: formData,
    dataType: 'json',
    success: function success(response) {
      if (response.errors && response.errors.length > 0) {
        $('.newsletter-form .error--email').show();
      } else {
        $('.newsletter-form .success--email').show();
      }
      _learnq.push(['identify', {
        '$email': email
      }]);
    },
    error: function error(_error) {
      $('.newsletter-form .error--email').show();
    }
  });
});

$('#newsletter--landing').submit(function (e) {
  e.preventDefault();
  if ($('.checkbox--newsletter').hasClass('checked')) {
    $('.checkbox--email').hide();
    var index = $(this).attr('form-index');
    var email = $('.email--newsletter[form-index="' + index + '"]').val().toLowerCase();
    var fields = "$source,$email,$consent,$landingPage";
    var formData = {
      "email": email,
      "g": $('.list--newsletter-new[form-index="' + index + '"]').val(),
      "$consent": "email",
      "$source": $('.newsletter-form[form-index="' + index + '"]').attr('source'),
      "$landingPage": window.landing && window.landing.tag || "landing-page",
      "$fields": fields
    };

    $.ajax({
      type: "POST",
      url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
      data: formData,
      dataType: 'json',
      success: function success(response) {
        if (response.errors && response.errors.length > 0) {
          $('.newsletter-form .error--email').show();
        } else {
          $('.newsletter-form .success--email').show();
        }
        _learnq.push(['identify', {
          '$email': email
        }]);
      },
      error: function error(_error2) {
        $('.newsletter-form .error--email').show();
      }
    });
  } else {
    $('.checkbox--email').show();
  }
});

$('.click-gender').on('click', function () {
  if ($(this).hasClass('active')) {} else {
    $('.click-gender').removeClass('active');
    $(this).addClass('active');
  }
});

$('#newsletter--concours').submit(function (e) {
  e.preventDefault();
  if ($('.checkbox--newsletter').hasClass('checked')) {
    $('.checkbox--email').hide();
    var index = $(this).attr('form-index');
    var source = $('.newsletter-form[form-index="' + index + '"]').attr('source');
    var prenom = $('.prenom--newsletter[form-index="' + index + '"]').val().toLowerCase();
    var nom = $('.nom--newsletter[form-index="' + index + '"]').val().toLowerCase();
    var email = $('.email--newsletter[form-index="' + index + '"]').val().toLowerCase();
    var gender = $('.gender--newsletter.active[form-index="' + index + '"]').attr('type');
    var fields = "$source,$email,$prenom,$nom,$gender,$consent,$landingPage";
    var formData = {
      "email": email,
      "g": $('.list--newsletter-new[form-index="' + index + '"]').val(),
      "$consent": "email",
      "$source": source,
      "$prenom": prenom,
      "$nom": nom,
      "$gender": gender,
      "$landingPage": window.landing && window.landing.tag || "landing-page",
      "$fields": fields
    };

    $.ajax({
      type: "POST",
      url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
      data: formData,
      dataType: 'json',
      success: function success(response) {
        if (response.errors && response.errors.length > 0) {
          $('.newsletter-form .error--email').show();
        } else {
          $('.newsletter-form .success--email').show();
          window.location.href = "/pages/validation-concours";
        }
        _learnq.push(['identify', {
          '$email': email
        }]);
      },
      error: function error(_error3) {
        $('.newsletter-form .error--email').show();
      }
    });
  } else {
    $('.checkbox--email').show();
  }
});

$('#newsletter--validation').submit(function (e) {
  e.preventDefault();
  var index = $(this).attr('form-index');
  var name = $('.prenom--newsletter[form-index="' + index + '"]').val();
  var name2 = $('.prenom--newsletter[form-index="' + index + '"]').val();
  if (name != "" && name2 != "") {
    $('.checkbox--email, .error--name').hide();
    var source = $('.newsletter-form[form-index="' + index + '"]').attr('source');
    var prenom = $('.prenom--newsletter[form-index="' + index + '"]').val();
    var nom = $('.nom--newsletter[form-index="' + index + '"]').val();
    var email = $('.email--newsletter[form-index="' + index + '"]').val().toLowerCase();
    var gender = $('.gender--newsletter.active[form-index="' + index + '"]').attr('type');
    var fields = "$source,$email,$first_name,$nom,$gender,$consent,$landingPage";
    var formData = {
      "email": email,
      "g": $('.list--newsletter-new[form-index="' + index + '"]').val(),
      "$consent": "email",
      "$source": source,
      "first_name": prenom,
      "$nom": nom,
      "$gender": gender,
      "$landingPage": window.landing && window.landing.tag || "landing-page",
      "$fields": fields
    };

    $.ajax({
      type: "POST",
      url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
      data: formData,
      dataType: 'json',
      success: function success(response) {
        if (response.errors && response.errors.length > 0) {
          $('.newsletter-form .error--email').show();
        } else {
          $('.newsletter-form .success--email').show();
        }
        _learnq.push(['identify', {
          '$email': email
        }]);
      },
      error: function error(_error4) {
        $('.newsletter-form .error--email').show();
      }
    });
  } else {
    $('.newsletter-form .error--name').show();
  }
});

$('.checkbox-manucurist--container').on('click', function () {
  if ($(this).children('.checkbox--newsletter').hasClass('checked')) {
    $(this).children('.checkbox--newsletter').removeClass('checked');
  } else {
    $(this).children('.checkbox--newsletter').addClass('checked');
  }
});

$(document).on('scroll', function () {

  if (window.matchMedia("(max-width: 767px)").matches) {
    if ($(window).scrollTop() > 300) {
      $('.imageScroll').addClass('display__none');
    } else {
      $('.imageScroll').removeClass('display__none');
    }
  } else {
    if ($(window).scrollTop() > 300) {
      $('.imageScroll').addClass('display__none');
    } else {
      $('.imageScroll').removeClass('display__none');
    }
  }
  if ($(window).scrollTop() >= 0) {
    $('.imageScroll').css('transform', 'scale(' + (1 + $(window).scrollTop() / 30) + ')');
  }
});
'use strict';

var whiteNavBar = function whiteNavBar() {
  $('#main__logo--svg').removeClass('logo--white');
  $('.link--text-style').removeClass('white');
  $('#icon-account .icon--compte').removeClass('logo--white');
  $('#icon-cart .icon--panier').removeClass('logo--white');
  $('#icon-cart .items--count').removeClass('white');
  $('#icon-search .icon--search').removeClass('logo--white');
  $('#icon-underline .icon--soulignement').removeClass('logo--white');
  $('.icon--sac-boutique-wisp').removeClass('white');
  $('.iwish--container').removeClass('logo--white');
};

var transparentNavbar = function transparentNavbar() {
  if ($(".collection-tile--section")[0]) {
    $('#main__logo--svg').removeClass('logo--white');
    $('.link--text-style').removeClass('white');
    $('#icon-account .icon--compte').removeClass('logo--white');
    $('#icon-cart .icon--panier').removeClass('logo--white');
    $('#icon-cart .items--count').removeClass('white');
    $('#icon-search .icon--search').removeClass('logo--white');
    $('#icon-underline .icon--soulignement').removeClass('logo--white');
    $('.icon--sac-boutique-wisp').removeClass('white');
    $('.iwish--container').removeClass('logo--white');
  } else {
    $('#main__logo--svg').addClass('logo--white');
    $('.link--text-style').addClass('white');
    $('#icon-account .icon--compte').addClass('logo--white');
    $('#icon-cart .icon--panier').addClass('logo--white');
    $('#icon-cart .items--count').addClass('white');
    $('#icon-search .icon--search').addClass('logo--white');
    $('#icon-underline .icon--soulignement').addClass('logo--white');
    $('.icon--sac-boutique-wisp').addClass('white');
    $('.iwish--container').addClass('logo--white');
  }
};

var handleBarChange = function handleBarChange() {
  if ($(".collection-tile--section")[0]) {
    $("#navigation--container").removeClass("transparent--nav");
    transparentNavbar();
  } else {
    if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
      $("#navigation--container").addClass('transparent--nav');
      transparentNavbar();
    }
  }
};
if ($(".collection-tile--section")[0]) {
  $("#navigation--container").removeClass("transparent--nav");
  handleBarChange();
} else {
  if (window.location.pathname == "/" || window.general.headerTransparent == 1) {
    if (window.location.href.indexOf("product") > -1) {
      if (window.matchMedia("(min-width: 1101px)").matches) {

        if ($(document).scrollTop() < 20) {
          if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
            $("#navigation--container").addClass('transparent--nav');
          }
          $('#navigation--container').mouseenter(function () {
            $(this).removeClass('transparent--nav');
          });

          $('#navigation--container').mouseleave(function () {
            if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
              $("#navigation--container").addClass('transparent--nav');
            }
          });
        }

        if ($(document).scrollTop() > 20) {
          $("#navigation--container").removeClass('transparent--nav');
          $("#navigation--container").addClass('scrolled--nav');
        }

        $(document).on('scroll', function () {
          if ($(document).scrollTop() > 20) {
            $("#navigation--container").removeClass('transparent--nav');
            $("#navigation--container").addClass('scrolled--nav');
          } else {
            if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
              $("#navigation--container").addClass('transparent--nav');
            }
            $("#navigation--container").removeClass('scrolled--nav');

            $('#navigation--container').mouseleave(function () {
              if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
                $("#navigation--container").addClass('transparent--nav');
              }
            });
          }
        });
      }
    } else {
      if (window.matchMedia("(min-width: 1101px)").matches) {

        if ($(document).scrollTop() < 20) {
          if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
            $("#navigation--container").addClass('transparent--nav');
          }
          $('#navigation--container').mouseenter(function () {
            $(this).removeClass('transparent--nav');
            whiteNavBar();
          });

          $('#navigation--container').mouseleave(function () {
            handleBarChange();
          });
        } else {
          $("#navigation--container").removeClass('transparent--nav');
          $("#navigation--container").addClass('scrolled--nav');
          whiteNavBar();
        }

        $(document).on('scroll', function () {
          if ($(document).scrollTop() > 20) {
            $("#navigation--container").removeClass('transparent--nav');
            $("#navigation--container").addClass('scrolled--nav');
            whiteNavBar();

            $('#navigation--container').mouseleave(function () {
              whiteNavBar();
            });
          } else {
            handleBarChange();

            $("#navigation--container").removeClass('scrolled--nav');
            $('#navigation--container').mouseleave(function () {
              handleBarChange();
            });
          }
        });
      }
    }
  }

  // Gestion du scroll
  if (window.matchMedia("(max-width: 1100px)").matches) {
    if ($(document).scrollTop() > 20) {
      $('#navigation__drawer').addClass('scroll-drawer');
    } else {
      $('#navigation__drawer').removeClass('scroll-drawer');
    }
    $(document).on('scroll', function () {
      if ($(document).scrollTop() > 20) {
        $('#navigation__drawer').addClass('scroll-drawer');
      } else {
        $('#navigation__drawer').removeClass('scroll-drawer');
      }
    });
  }

  $('#accordion-navigation .plus__icon').show();
  $('#accordion-navigation').find('li.extend').click(function (e) {
    $(this).children('.extended-submenu').slideToggle('fast');
    $(this).children('.nav--title').children('.plus__icon').toggleClass('opened');
    $(this).toggleClass('active');
  });
}
'use strict';

$('#reset-password').click(function () {
  $('#connexion').css('display', 'none');
  $('#reset').fadeIn("slow");
});
'use strict';

document.addEventListener('cart:open', function (elem) {
  if (window.cart.cartType == 'preview') {
    $('#cart__preview').addClass('opened--added-to-cart');
    $('.link--text-style--cart').addClass('link__active');

    if (window.matchMedia("(max-width: 1100px)").matches) {
      $('#page__overlay--navigation').addClass('opened');
    } else {
      setTimeout(function () {
        $('#cart__preview').removeClass('opened--added-to-cart');
        if ($('#cart__preview').hasClass('opened') == false) {
          $('.link--text-style--cart').removeClass('link__active');
        }
      }, 4000);
    }
  } else {
    $("#cart__drawer").addClass('opened');
    $('#page__overlay').addClass('opened');
    $('#page__overlay').attr('for', 'drawer');
    setTimeout(function () {
      $('#drawer__cart--exta-infos').addClass('opened');
    }, 350);
  }
}, false);

var updateCartButton = function updateCartButton() {
  $.ajax({
    type: 'GET',
    url: '/cart',
    dataType: 'json',
    success: function success(response) {
      var total = response.total_price;
      var empty = response.item_count == 0 ? true : false;
      updateDeliveryPreview(total);
      updateDeliveryModule(total);
      if (empty) {
        $('.cart--body').addClass('empty__cart');
        // $('.cart__total--drawer, .vertical--separator').addClass('display__none');
        $('.empty__cart--drawer').removeClass('display__none');
        $('.items--count').text(0);
        $('.items--count').addClass("cart-link__badge--hidden");

        if ($('#full__cart--title').length > 0) {
          location.reload(true);
        }
      } else {
        $('.cart--body').removeClass('empty__cart');
        $('.items--count').removeClass("cart-link__badge--hidden");
        $('.empty__cart--drawer').addClass('display__none');
        // $('.cart__total--drawer, .vertical--separator').removeClass('display__none');
        // $('.cart__total--drawer').text(displayPrice(total));

        $('.items--count').text(response.item_count);

        $('.cart__item--total-price').text(displayPrice(total));
        response.items.forEach(function (line_item) {
          var variantId = line_item.variant_id;

          // On affiche offert si cest un emballage
          if (variantId == 32742629081223) {
            $('.cart__item--container[variant-id=' + variantId + '] .cart__item--total-price').text("OFFERT");
          } else {
            $('.cart__item--container[variant-id=' + variantId + '] .cart__item--total-price').text(displayPrice(line_item.line_price));
          }
        });
      }
    },
    error: function error(_error) {
    }
  });
};

var updateDeliveryPreview = function updateDeliveryPreview(total) {
  if (window.cart.deliveryModule) {
    var deliveryLimit = window.cart.freeDelivery - 1;
    var remainPercentage = Math.max(0, (deliveryLimit - total) / deliveryLimit * 100);
    var remainMoney = Math.max(0, (deliveryLimit + 1 - total) / 100);

    if (remainMoney == window.cart.freeDelivery / 100) {
      $('#free__shipping--message-preview').hide();
      $('#remain__shipping__amount--message-preview').show();
      $('#remain__shipping__amount--message-preview').text('Livraison offerte en France d\xE8s ' + window.cart.freeDelivery / 100 + '\u20AC d\'achats.');
    } else if (remainMoney > 0) {
      $('#free__shipping--message-preview').hide();
      $('#remain__shipping__amount--message-preview').show();
      $('#remain__shipping__amount--message-preview').html('Plus que <span class="amount__remaining fw--700">' + remainMoney + '\u20AC</span> pour b\xE9n\xE9ficier de la livraison offerte en France');
    } else {
      $('#free__shipping--message-preview').show();
      $('#remain__shipping__amount--message-preview').hide();
    }
  }
};
'use strict';

// Add to cart function
if (window.cart && window.location.pathname == "/cart") {
  window.cart.drawer = false;
}

$('.checkout--button').find('.loader--button').hide();
$('.checkout--button').find('.wording--button').show();

$('.filter__group--title').on('click', function () {
  $(this).children('plus__icon').toggleClass('opened');
  $(this).siblings('.filter__group--item-list').slideToggle(300);
  $(this).toggleClass('opened');
});

$('.checkout--button').on('click', function () {
  $(this).find('.loader--button').css('display', 'block');
  $(this).find('.wording--button').hide();
});

$('body').on('click', '.add__to__cart--cart-page', function (e) {
  e.preventDefault();
  var variantId = $(this).attr('variant-id');
  var initialText = $(this).text().trim();
  var available = $(this).attr('variant-available');
  var price = $(this).attr('product-price');
  var $this = $(this);
  var handle = $(this).attr('product-handle');
  var name = $(this).attr('product-name');
  var sku = $(this).attr('product-sku');
  $(this).find('.loader--button').css('display', 'block');
  $(this).find('.wording--button').hide();

  if (available == 'true' || available == true) {
    var objUpdate = { quantity: 1, id: variantId };
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: objUpdate,
      dataType: 'json',
      success: function success(response) {
        if (typeof ga === "function") {
          ga('send', 'event', 'Produit recommandé', 'Panier', handle);
        }
        renderCart();
        updateCartButton();
        $this.find('.loader--button').hide();
        $this.find('.wording--button').css('display', 'block');

        if (window.dataLayer) {
          window.dataLayer.push({
            "event": "addtocart",
            "addCartName": name,
            "addCartSku": sku,
            "productPriceAdd": parseFloat(price),
            "quantity": 1,
            "totalPrice": parseFloat(price)
          });
        }
      },
      error: function error(_error) {
        setTimeout(function () {
          $this.addClass('choose-size');
          $this.text("Choisissez votre taille");
          $this.find('.wording--cart').show();
          $this.find('.loader--button').hide();
        }, 500);

        setTimeout(function () {
          $this.text(initialText);
          $this.removeClass('choose-size');
        }, 3000);
      }
    });
  }
});

$('body').on('click', '.add__to__cart', function (e) {
  e.preventDefault();

let variantId = null;

// 1️⃣ Product page → safe to use Shopify product object
if (window.product?.selected_or_first_available_variant?.id) {
  variantId = window.product.selected_or_first_available_variant.id;
} else {
  // 2️⃣ Collection tiles → rely on button attribute
  variantId = $(this).attr('variant-id');
}

if (!variantId) {
  console.error("No variant ID detected!", this);
  return;
}



  var available = $(this).attr('variant-available');
  var productHandle = $(this).attr('product-handle');
  var variants = $(this).attr('variants');
  var type = $(this).attr('button-type');
  var openModale = $(this).attr('open-selector');
  var price = $(this).attr('product-price');
  var name = $(this).attr('product-name');
  var sku = $(this).attr('product-sku');
  if (available == 'true' || available == true) {
    if (variants && openModale) {
      document.dispatchEvent(new CustomEvent('product-grid-modal:open', { 'detail': { productHandle: productHandle } }));
    } else if (variantId) {
      var qty = 1;
      /*if (type == 'product') {
        qty = $('.product__qty--container .quantity__current').val();
      }*/
      var objUpdate = { quantity: qty, id: variantId, properties: {} };
      if ($(this).hasClass('giftCard')) {
        var mail = $('#recipient-mail-destinataire').val();
        var name = $('#recipient-name').val();
        var message = $('#recipient-message').val();
        var date = $('#recipient-date').val();

        var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

        if (!mail) {
          $('.error-mail').show();
          setTimeout(function () {
            $('.error-mail').hide();
          }, 2000);
          return;
        } else if (!emailRegex.test(mail)) {
          $('.error-mail-mail').show();
          setTimeout(function () {
            $('.error-mail-mail').hide();
          }, 2000);
          return;
        }

        objUpdate.properties = {
          __shopify_send_gift_card_to_recipient: true,
          'Recipient email': mail,
          'Recipient name': name,
          Message: message,
          'Send on': date
        };
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: objUpdate,
        dataType: 'json',
        success: function success(response) {
          renderCart();
          updateCartButton();
          // Pinterest
          //pintrk('track', 'addtocart', { value: price, order_quantity: 1, currency: 'EUR' });

          if (window.dataLayer) {
            var totalTransaction = parseFloat(price) * parseFloat(qty);
            totalTransaction = totalTransaction.toFixed(2);
            window.dataLayer.push({
              "event": "addtocart",
              "addCartName": name,
              "addCartSku": sku,
              "productPriceAdd": parseFloat(price),
              "quantity": parseInt(qty),
              "totalPrice": parseFloat(totalTransaction)
            });
          }

          if ($('#empty__cart--title').length > 0) {
            location.reload(true);
          }

          function getCookie(name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length == 2) return parts.pop().split(";").shift();
          }

          var openLookbook = true;
          // if (window.product.productLook == false || getCookie('lookbook') == '1' || window.matchMedia("(max-width: 767px)").matches || matchMedia("(max-height: 600px)").matches) {
          //   openLookbook = false;
          // }

          if (window.cart && window.cart.drawer && openLookbook === false) {
            document.dispatchEvent(new CustomEvent('cart:open'));
          } else if (window.location.pathname.match(/products\/gift-card/)) {
            window.location = "/cart";
          } else {
            $('#page__overlay').addClass('opened');
            $('#page__overlay').attr('for', 'modal');
            $('#modale--produits-du-look').addClass('opened');

            ga('send', 'event', "Produit", "Lookbook", "Ouverture pop up - Auto");

            var cookieDate = new Date();
            cookieDate.setHours(cookieDate.getHours() + 4);
            document.cookie = "lookbook=1; expires=" + cookieDate.toGMTString() + "; path=/";
          }
        },
        error: function error(_error2) {
        }
      });
    }
  }
});

$('body').on('click', '.quantity__change--selector', function (e) {
  e.preventDefault();
  var $this = $(this);
  var variantId = $(this).attr('variant-id');
  var variantQty = $(this).attr('variant-qty');
  var type = $(this).attr('type');

  if (variantId) {
    var data = { updates: {} };
    data.updates[variantId] = variantQty;
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function success(response) {
        $('.quantity__current[variant-id="' + variantId + '"]').val(variantQty);
        if (type == 'remove' || variantQty == 0) {
          $('.cart__item--container[variant-id="' + variantId + '"]').remove();
          if ($('.cart__item--container').length == 0) {
            location.reload(true);
          } else {
            document.dispatchEvent(new CustomEvent('update-reco-cart'));
          }
        } else if (type == 'minus' || type == "plus") {
          var minusQty = parseInt(variantQty) - 1;
          var plusQty = parseInt(variantQty) + 1;
          // On limite le nombre d emballages cadeau
          if (variantId == 32742629081223) {
            if (plusQty >= 2) {
              $('.alert--qty').show();
              setTimeout(function () {
                $('.alert--qty').hide();
              }, 2500);
            }
            minusQty = Math.min(minusQty, 2);
            plusQty = Math.min(plusQty, 3);
          }
          $('.quantity__change--selector[type="minus"][variant-id="' + variantId + '"]').attr('variant-qty', minusQty);
          $('.quantity__change--selector[type="plus"][variant-id="' + variantId + '"]').attr('variant-qty', plusQty);
        }
        updateCartButton();

        if (window.cart && window.cart.drawer && window.location.pathname != "/cart") {
          document.dispatchEvent(new CustomEvent('cart:open'));
        }
      },
      error: function error(_error3) {
      }
    });
  }
});

var renderCart = function renderCart() {
  var url = '/cart?view=sidecart&timestamp=' + Date.now();

  if (window.location.pathname == '/cart') {
    url = '/cart?view=page&timestamp=' + Date.now();
  }

  $.ajax({
    type: 'GET',
    url: url,
    success: function success(content) {
      var newCart = content;
      $('.cart__items__and__header--container').remove();
      if (window.location.pathname == '/cart') {
        $('.cart__drawer--body').append(newCart);
        if ($('.cart__item--container').length == 0) {
          location.reload(true);
        }
        document.dispatchEvent(new CustomEvent('update-reco-cart'));
      } else {
        $('.cart--body').append(newCart);
      }
    },
    error: function error(_error4) {
    }
  });
};

if (window.cart && window.cart.drawer == true) {
  renderCart();
}

// =============================================================================
// Champs commentaire panier
// =============================================================================
if (window.location.pathname == '/cart' && $('#Commentaire').length > 0) {
  var nbCharacters = $('#Commentaire').val().length;
  $('#compteur--comment').text(nbCharacters);

  $('#Commentaire').on('change keyup', function (e) {
    e.preventDefault();
    nbCharacters = $('#Commentaire').val().length;
    var val = $('#Commentaire').val();

    if (nbCharacters > 100) {
      $('#Commentaire').val(val.substring(0, 100));
      $('#compteur__comment--container').addClass('error');
      $('#compteur--comment').text("100");
      setTimeout(function () {
        $('#compteur__comment--container').removeClass('error');
      }, 600);
    } else {
      $('#compteur--comment').text(nbCharacters);
    }
  });
}
'use strict';

var pageOverlayOpened = false;
$(".navigation__item--link-megamenu").mouseenter(function () {
  if (pageOverlayOpened == false) {
    $(this).children('.navigation__item--link').addClass('link__active');
    $('#page__overlay--navigation').addClass('opened');
    pageOverlayOpened = true;
  }
});

$(".navigation__item--link-megamenu").mouseleave(function () {
  if (pageOverlayOpened == true) {
    $(this).children('.navigation__item--link').removeClass('link__active');
    $('#page__overlay--navigation').removeClass('opened');
    pageOverlayOpened = false;
  }
});

$('.sub_sub_link--link').each(function (index) {
  var imageUrl = $(this).attr('img-url');
  if (imageUrl) {
    var img = new Image();
    img.src = imageUrl;
  }
});

$('#navigation__drawer a').on('click', function () {
  $('#navigation__drawer').hide();
  $('#gif-mobile--container').css('display', 'flex');
  $('#page__overlay').removeClass('opened');
  $('#page__overlay').attr('for', '');
  $('#MainContent').fadeOut(300);
  $('#shopify-section-instagram-feed').fadeOut(300);
  $('#shopify-section-bandeau-footer').fadeOut(300);
  $('#shopify-section-footer').fadeOut(300);
});
'use strict';

$('body').on('click', '.bulle__custom--value-look', function () {
  var value = $(this).text();
  var product_id = $(this).attr('product-id');
  var variant_id = $(this).attr('variant-id');
  var availability = $(this).attr('variant-available');
  var sku = $(this).attr('sku');

  if (availability == "true") {
    $('.bulle__custom--value-look[product-id="' + product_id + '"]').removeClass('is__active');
    $(this).addClass('is__active');
    $('.add__to__cart--look[product-id="' + product_id + '"]').attr('variant-id', variant_id);
    $('.add__to__cart--look[product-id="' + product_id + '"]').attr('product-sku', sku);
    $('.size-hidden--container').css('display', 'none');
    $('.size-visible[product-id="' + product_id + '"]').text(value);
    $('.size-visible--container').removeClass('is-click');
  }
});

$(document).on('click', function (e) {
  var container = $(".size-hidden--container");
  if ($(e.target).hasClass('size-hidden-click') || $(e.target).hasClass('size-visible--container') || $(e.target).hasClass('select__cases--container') || $(e.target).hasClass('size-visible')) {} else {
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $('.size-visible--container').siblings('.size-hidden--container').css('display', 'none').removeClass('size-hidden-click');
      $('.size-visible--container').removeClass('is-click');
    }
  }
});

$('body').on('click', '.size-visible--container', function () {
  if ($(this).hasClass('is-click')) {
    $(this).siblings('.size-hidden--container').css('display', 'none').removeClass('size-hidden-click');
    $(this).removeClass('is-click');
  } else {
    $(this).siblings('.size-hidden--container').css('display', 'block').addClass('size-hidden-click');
    $(this).addClass('is-click');
  }
});

$('body').on('click', '.add__to__cart--look', function (e) {
  e.preventDefault();
  $(this).find('.wording--cart').hide();
  $(this).find('.loader--button').css('display', 'block');
  var variantId = $(this).attr('variant-id');
  var initialText = $(this).text().trim().toUpperCase();
  var data = { quantity: 1, id: variantId };
  var $this = $(this);
  var handle = $(this).attr('product-handle');
  var name = $(this).attr('product-name');
  var sku = $(this).attr('product-sku');
  var price = $(this).attr('product-price');
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function success(response) {
      if (typeof ga === "function") {
        ga('send', 'event', 'Produit recommandé', 'Produit', handle);
      }
      if (window.dataLayer) {
        window.dataLayer.push({
          "event": "addtocart",
          "addCartName": name,
          "addCartSku": sku,
          "productPriceAdd": parseFloat(price),
          "quantity": 1,
          "totalPrice": parseFloat(price)
        });
      }
      updateCartButton();
      renderCart();
      setTimeout(function () {
        $this.text("PRODUIT AJOUTÉ !");
        $this.find('.wording--cart').show();
        $this.find('.loader--button').hide();
        setTimeout(function () {
          window.location.replace('/cart');
        }, 1000);
      }, 1000);

      setTimeout(function () {
        $this.text(initialText);
      }, 3000);
    },
    error: function error(_error) {
      setTimeout(function () {
        $this.addClass('choose-size');
        $this.text("Choisissez votre taille");
        $this.find('.wording--cart').show();
        $this.find('.loader--button').hide();
      }, 500);

      setTimeout(function () {
        $this.text(initialText);
        $this.removeClass('choose-size');
      }, 3000);
    }
  });
});

$('#continue--shopping').on('click', function () {
  $('.close--container-crossell').click();
});
'use strict';

var productDetails = {};
if ($('[product-details]').html()) {
  productDetails = JSON.parse($('[product-details]').html());
}

$('.quantity__change--selector-product').on('click', function () {
  var type = $(this).attr('type');
  var currentQty = parseInt($('.product__qty--container .quantity__current').val());

  if (type == 'minus') {
    if (currentQty != 0) {
      $('.product__qty--container .quantity__current').val(currentQty - 1);
    }
  } else {
    $('.product__qty--container .quantity__current').val(currentQty + 1);
  }
});

document.addEventListener('select-changed:product__option--1', function (event) {
  if (event.detail.quickAdd == "true") {
    onOptionChangedQuickAdd();
  } else {
    onOptionChanged();
  }
}, false);

document.addEventListener('select-changed:product__option--2', function (event) {
  if (event.detail.quickAdd == "true") {
    onOptionChangedQuickAdd();
  } else {
    onOptionChanged();
  }
}, false);

document.addEventListener('select-changed:product__option--3', function (event) {
  if (event.detail.quickAdd == "true") {
    onOptionChangedQuickAdd();
  } else {
    onOptionChanged();
  }
}, false);

// Change variant for bulles
$('.bulle__custom--value').on('click', function () {
  var value = $(this).text();
  var option = $(this).attr('for');
  var product_id = $(this).attr('product-id');

  $('.select__custom--selected-value[for="' + option + '"][product-id="' + product_id + '"]').text(value);
  $('.bulle__custom--value[for="' + option + '"][product-id="' + product_id + '"]').removeClass('is__active');
  $(this).addClass('is__active');

  document.dispatchEvent(new CustomEvent('select-changed:' + option, { 'detail': { quickAdd: "false" } }));
});

$('.rectangle__custom--value').on('click', function () {
  var value = $(this).text();
  var option = $(this).attr('for');

  $('.select__custom--selected-value[for="' + option + '"]').text(value);
  $('.rectangle__custom--value[for="' + option + '"]').removeClass('is__active');
  $(this).addClass('is__active');

  document.dispatchEvent(new CustomEvent('select-changed:' + option, { 'detail': { quickAdd: "false" } }));
});

var currentButtonText = $('.add__to__cart .body__text--button-small').first().text().trim();

function updateProductButton(variant, productId) {
  if (variant.available == false) {
    $('.add__to__cart[product-id="' + productId + '"]').html('<span class="text__center body__text--button-small primary__color--light text__uppercase">\n          S\'INSCRIRE \xC0 L\'ALERTE\n        </span>');
    $('.add__to__cart[product-id="' + productId + '"]').attr('id', 'BIS_trigger');
    $('.add__to__cart[product-id="' + productId + '"]').attr('variant-available', false);
    $('.add__to__cart[product-id="' + productId + '"]').attr('data-variant-id', variant.id);
    $('.add__to__cart[product-id="' + productId + '"]').attr('product-sku', variant.sku);
  } else {
    if (productDetails.precommande == "true") {
      $('.add__to__cart[product-id="' + productId + '"]').html('<span class="text__center body__text--button-small primary__color--light text__uppercase">' + productDetails.text_preco + '</span>');
    } else {
      $('.add__to__cart[product-id="' + productId + '"]').html('<span class="text__center body__text--button-small primary__color--light text__uppercase">Ajouter au panier</span>');
    }

    $('.add__to__cart[product-id="' + productId + '"]').attr('id', '');
    $('.add__to__cart[product-id="' + productId + '"]').attr('variant-available', true);
    $('.add__to__cart[product-id="' + productId + '"]').attr('product-sku', variant.sku);
  }
}

function onOptionChanged() {
  var productOptions = [];

  for (var i = 1; i <= 3; i++) {
    productOptions[i - 1] = $('.select-variant-cart .select__custom--selected-value[product-id="' + productDetails.productId + '"][name="product__option--' + i + '"]').text().trim() || "";
  }
  if (productDetails && productDetails.variants.length > 1) {
    productDetails.variants.forEach(function (variant) {
      if (variant.option1 == productOptions[0] && variant.option2 == productOptions[1] && variant.option3 == productOptions[2]) {
        if (variant.availableQty > 0 && variant.availableQty <= 3) {
          $('#sentence-product-left').show();
          var quantity = variant.availableQty;
          //document.getElementById("number-product").innerHTML = quantity ;
          $('.product-left-number').text(quantity);
          if (quantity == 1) {
            document.getElementById("word-product").innerHTML = "produit";
          } else {
            document.getElementById("word-product").innerHTML = "produits";
          }
        } else {
          $('#sentence-product-left').hide();
        }

        $('.product--price').text(variant.price);
        $('.product--compare-at-price').text(variant.compareAtPrice);
        $('.add__to__cart[product-id="' + productDetails.productId + '"]').attr('variant-id', variant.id);
        var url = document.location.origin + document.location.pathname + ('?variant=' + variant.id);
        window.history.replaceState({ path: url }, '', url);

        updateProductButton(variant, productDetails.productId);
      }
    });
  }
}

// ================================================
// Navigation accordeon
// ================================================

var navigationDesProduct = undefined;
function initNavigationDesProduct() {
  if (window.matchMedia("(max-width: 767px)").matches && navigationDesProduct == undefined) {
    $('.sidebar-accordion-description-product .plus__icon').show();
    $('.sidebar-accordion-description-product').find('li.extend').click(function (e) {
      $(this).children('.extended-submenu').slideToggle('fast');
      $(this).children('.nav__des-product--title').children('.plus__icon').toggleClass('opened');
      $(this).toggleClass('active');
    });
    navigationDesProduct = 1;
  } else if (window.matchMedia("(min-width: 768px)").matches && navigationDesProduct != undefined) {
    $('.sidebar-accordion-description-product').find('li.extend').off('click');
    $('.sidebar-accordion-description-product .extended-submenu').show();
    $('.sidebar-accordion-description-product .plus__icon').hide();
    navigationDesProduct = undefined;
  }
}
initNavigationDesProduct();

$(window).on('resize', function () {
  initNavigationDesProduct();
});

// ================================================
// Social link share
// ================================================
if (window.location.pathname.indexOf("product") > -1) {
  var CheminComplet = document.location.href;
  var CheminCompletFb = "http://www.facebook.com/sharer.php?u=" + CheminComplet + "&t=partage";
  var CheminCompletPinterest = "http://pinterest.com/pin/create/button/?url=" + CheminComplet + "&media=" + window.product.featuredImage;
  var CheminCompletWhatsapp = "whatsapp://send?text=" + encodeURIComponent(CheminComplet);
  $("#share-link--facebook").attr("href", CheminCompletFb);
  $("#share-link--pinterest").attr("href", CheminCompletPinterest);
  $("#share-link--whatsapp").attr("href", CheminCompletWhatsapp);
}

// ================================================
// Ancre en savoir plus
// ================================================
$('#details__anchor').on('click', function () {
  var id = $(this).attr('href');

  $('html, body').animate({
    scrollTop: $(id).offset().top - 150
  }, 500);
});
$('.anchor--details').on('click', function () {
  var id = $(this).attr('href');

  $('html, body').animate({
    scrollTop: $(id).offset().top - 70
  }, 500);
});

/*$('.tabs').each(function(){
  var active, content, links = $(this).find('a');
  active = links.first().addClass('active');
  content = $(active.attr('href'));
  links.not(':first').each(function () {
    $($(this).attr('href')).hide();
  });
  $(this).find('a').click(function(e){
    active.removeClass('active');
    content.hide();
    active = $(this);
    content = $($(this).attr('href'));
    active.addClass('active');
    content.show();
    return false;
  });
});*/

$('.click-title').on('click', function () {
  if ($(this).hasClass('active')) {} else {
    $('.click-title').removeClass('active');
    $(this).addClass('active');
    $('.tab-new').addClass('hidden-div').removeClass('show-div');
    var div = $(this).attr('link');
    $('' + div).removeClass('hidden-div').addClass('show-div');
  }
});

$('body').on('click', '.selecteur-mobile-size--container', function () {
  $('.hidden-selecteur-size-mobile--container').addClass('opened');
  $('#page__overlay').addClass('opened');
});

$('body').on('click', '.no-product-variant', function () {
  $('.selecteur-mobile-size--container').click().addClass('special-add');
  //$('.add__to__cart').removeClass('no-product-variant')
});

$('body').on('click', '.selecteur-imprime-mobile--container', function () {
  $('.custom-field__existe-aussi-dans-cet-imprime').addClass('opened');
  $('#page__overlay').addClass('opened');
});

$('body').on('click', '.close-selecteur-mobile', function () {
  $('.hidden-selecteur-size-mobile--container, .custom-field__existe-aussi-dans-cet-imprime').removeClass('opened');
  $('#page__overlay').removeClass('opened');
});

$('.bulle__custom--value-mobile').on('click', function () {
  var value = $(this).find('.size').text();
  var sentence = $(this).find('.sentence-product-left').text();
  var option = $(this).attr('for');
  var product_id = $(this).attr('product-id');

  if ($('.add__to__cart[product-id="' + product_id + '"]').hasClass('no-product-variant')) {
    $('.add__to__cart[product-id="' + product_id + '"]').removeClass('no-product-variant');
  }

  $('.select__custom--selected-value[for="' + option + '"][product-id="' + product_id + '"]').find('.size').text(value);
  $('.select__custom--selected-value[for="' + option + '"][product-id="' + product_id + '"]').find('.sentence-product-left').text(sentence);
  $('.bulle__custom--value-mobile[for="' + option + '"][product-id="' + product_id + '"]').removeClass('is__active');
  $(this).addClass('is__active');

  var productOptions = [];
  for (var i = 1; i <= 3; i++) {
    productOptions[i - 1] = $('.product__description--fiche .select__custom--selected-value[product-id="' + productDetails.productId + '"][name="product__option--' + i + '"]').find('.size').text().trim() || "";
  }
  if (productDetails && productDetails.variants.length > 0) {

    productDetails.variants.forEach(function (variant) {
      if (variant.option1 == productOptions[0] && variant.option2 == productOptions[1] && variant.option3 == productOptions[2]) {
        $('.product--price').text(variant.price);
        $('.product--compare-at-price').text(variant.compareAtPrice);
        $('.add__to__cart[product-id="' + productDetails.productId + '"]').attr('variant-id', variant.id);
        var url = document.location.origin + document.location.pathname + ('?variant=' + variant.id);
        window.history.replaceState({ path: url }, '', url);

        updateProductButton(variant, productDetails.productId);
      }
    });
  }
  $('.close-selecteur-mobile').click();

  setTimeout(function () {
    if ($('.selecteur-mobile-size--container[product-id="' + product_id + '"]').hasClass('special-add')) {
      $('.selecteur-mobile-size--container[product-id="' + product_id + '"]').removeClass('special-add');
      $('.add__to__cart[product-id="' + product_id + '"]').first().trigger('click');
    }
  }, 100);
});

$('.extra-info-drawer-size').on('click', function () {
  $('.hidden-selecteur-size-mobile--container').removeClass('opened');
});

if (window.matchMedia("(max-width: 767px)").matches) {
  $('.hover--tooltip-container').addClass('button__action').attr('for', 'tooltip').attr('open-selector', '#tooltip--container-help');
  $('.tooltip__action--button').children('.add__to__cart').not('.giftCard').attr('variant-id', '');;
}

if (window.matchMedia("(max-width: 767px)").matches) {
  $('.click-gift').on('click', function () {
    $('.hidden-input--container').slideToggle(200);
    //$('.add__to__cart').toggleClass('giftCard')
    $(this).children('.title').toggleClass('primary__color--medium dark__color');
    $(this).children('.plus__icon').toggleClass('opened');
  });
}
'use strict';

function updateProductButtonQuickAdd(variant) {
  $('.add__to__cart--quick-add').attr('variant-id', variant.id);

  if (variant.available == false) {
    $('.add__to__cart--quick-add').html('<span class="text__center fw--700 tertiary__color main__title--blog-categories ">\n          S\'INSCRIRE \xC0 L\'ALERTE\n        </span>');
    $('.add__to__cart--quick-add').attr('variant-available', 'false');
  } else {
    $('.add__to__cart--quick-add').html('<span class="text__center fw--700 tertiary__color main__title--blog-categories">Ajouter au panier\n    <span class="padding__horizontal--5">-</span>\n    <span class="product--price">' + displayPrice(variant.price) + '</span>');
    $('.add__to__cart--quick-add').attr('variant-available', 'true');
    $('.add__to__cart--quick-add').attr('id', '');
  }
}

function onOptionChangedQuickAdd() {
  var productOptions = [];

  for (var i = 1; i <= 3; i++) {
    productOptions[i - 1] = $('#product-grid-modal .select__custom--selected-value[name="product__option--' + i + '"]').text().trim() || "";
  }
  if (window.productGridDetails && window.productGridDetails.variants.length > 1) {
    window.productGridDetails.variants.forEach(function (variant) {
      if (variant.option1 == productOptions[0] && (variant.option2 == productOptions[1] || variant.option2 == null) && (variant.option3 == productOptions[2] || variant.option3 == null)) {

        $('#product-grid-modal .featured--img').attr('src', variant.featured_media.preview_image.src);
        $('#product-grid-modal .product--price').text(displayPrice(variant.price));
        if (variant.compare_at_price > variant.price) {
          $('#product-grid-modal .product--compare-at-price').text(displayPrice(variant.compare_at_price));
          var percentagePromo = "- " + Math.floor((parseInt(variant.compare_at_price) - parseInt(variant.price)) / parseInt(variant.compare_at_price) * 100) + "%";
          $('#product-grid-modal .body__text--collection-promo').text(percentagePromo);
          $('#product-grid-modal .sales__tag--container').show();
        } else {
          $('#product-grid-modal .product--compare-at-price').text("");
          $('#product-grid-modal .sales__tag--container').hide();
        }

        updateProductButtonQuickAdd(variant);
      }
    });
  }
}
'use strict';

if (window.location.pathname == '/cart') {
  document.addEventListener('update-reco-cart', function (e) {
    $.ajax({
      type: 'GET',
      url: 'https://' + window.location.hostname + '/?section_id=reco-cart-products',
      success: function success(data) {
        $('#reco__cart--container').empty().append(data);
        $("#shopify-section-reco-cart-products").show();

        if ($('#reco__cart--container').find('.swiper-slide').length > 0) {
          if (window.matchMedia("(max-width: 767px)").matches) {
            var swiperRecoCart = new Swiper('#reco__cart--swiper', {
              direction: 'horizontal',
              slidesPerView: 3,
              lazy: false,
              SpaceBetween: 0,
              noSwiping: true,
              navigation: {
                nextEl: '#swiper-next-reco',
                prevEl: '#swiper-prev-reco'
              },
              breakpoints: {
                767: {
                  slidesPerView: 2,
                  loop: true
                }
              }
            });
          }
        } else {
          $("#shopify-section-reco-cart-products").hide();
          $(".main__title--cart-reco").hide();
        }
      },
      error: function error(_error) {
      }
    });
  }, false);

  document.dispatchEvent(new CustomEvent('update-reco-cart'));

  $('body').on('click', '.bulle__custom--value-cart', function () {
    var value = $(this).text();
    var product_id = $(this).attr('product-id');
    var variant_id = $(this).attr('variant-id');
    var availability = $(this).attr('variant-available');

    if (availability == "true") {
      $('.bulle__custom--value-cart[product-id="' + product_id + '"]').removeClass('is__active');
      $(this).addClass('is__active');
      $('.add__to__cart--cart-page[product-id="' + product_id + '"]').attr('variant-id', variant_id);
      $('.size-hidden--container-cart').css('display', 'none');
      $('.size-visible[product-id="' + product_id + '"]').text(value);
      $('.size-visible--container-cart').removeClass('is-click');
    }
  });

  $(document).on('click', function (e) {
    var container = $(".size-hidden--container-cart");
    if ($(e.target).hasClass('size-hidden-click') || $(e.target).hasClass('size-visible--container-cart') || $(e.target).hasClass('select__cases--container') || $(e.target).hasClass('size-visible')) {} else {
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.size-visible--container-cart').siblings('.size-hidden--container-cart').css('display', 'none').removeClass('size-hidden-click');
        $('.size-visible--container-cart').removeClass('is-click');
      }
    }
  });

  $('body').on('click', '.size-visible--container-cart', function () {
    if ($(this).hasClass('is-click')) {
      $(this).siblings('.size-hidden--container-cart').css('display', 'none').removeClass('size-hidden-click');
      $(this).removeClass('is-click');
    } else {
      $(this).siblings('.size-hidden--container-cart').css('display', 'block').addClass('size-hidden-click');
      $(this).addClass('is-click');
    }
  });
}
'use strict';

if (window.cart) {
  var deliveryModuleWidth = 100;
  var renderFirst = 0;
  var nbSteps = 1;

  var shippingBarLogic = function shippingBarLogic(total) {
    var currentStep = 1;
    var remainMoney = 0;
    var remainPercentage = 0;
    var colorBar = 0;

    var barCalculus = function barCalculus(step, total) {
      var seuilSuivant = window.general.cartTotal * 100;
      var seuilPrecedent = 0;
      remainMoney = Math.max(0, (seuilSuivant - total) / 100);
      remainPercentage = Math.max(0, (seuilSuivant - total) / (seuilSuivant - seuilPrecedent));
      colorBar = deliveryModuleWidth * step - deliveryModuleWidth * remainPercentage;
    };

    var finalStep = function finalStep() {
      remainMoney = 0;
      remainPercentage = 0;
      colorBar = 100;
    };

    barCalculus(1, total);

    $('#progress__bar--remain').css('width', colorBar + '%');

    if (remainMoney > 0) {
      var moinsDix = remainMoney < 10 ? true : false;
      remainMoney = remainMoney.toString().replace('.', ',');
      if (moinsDix == true && remainMoney.length == 3) {
        remainMoney = remainMoney + '0';
      } else if (moinsDix == false && remainMoney.length == 4) {
        remainMoney = remainMoney + '0';
      }

      $('#free__shipping--message').hide();
      $('#remain__shipping__amount--message').show();
      $('.amount__remaining').text(remainMoney + "€");
    } else {
      $('#free__shipping--message').show();
      $('#remain__shipping__amount--message').hide();
    }
  };

  var getCartTotal = function getCartTotal(callback, cart) {
    if (cart) {
      if (callback) {
        callback(cart.total_price);
      } else {
        return cart.total_price;
      }
    } else {
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function success(cart) {
          if (callback) {
            callback(cart.total_price);
          } else {
            return cart.total_price;
          }
        }
      });
    }
  };

  var initializeDeliveryModule = function initializeDeliveryModule() {
    var total = getCartTotal(shippingBarLogic);
  };

  setTimeout(function () {
    initializeDeliveryModule();
  }, 1000);

  var updateDeliveryModule = function updateDeliveryModule(total) {
    if (total) {
      shippingBarLogic(total);
    } else {
      getCartTotal(shippingBarLogic);
    }
  };
}
'use strict';

if (window.matchMedia("(min-width: 1100px)").matches) {
  var scrollHeight = $('#swiper__product').height() - 200;
  if ($(document).scrollTop() > scrollHeight) {
    $('#add-to-cart--sticky').css('visibility', 'visible');
    setTimeout(function () {
      $('#add-to-cart--sticky').addClass('visible');
    }, 20);
  } else {
    $('#add-to-cart--sticky').removeClass('visible');
    setTimeout(function () {
      $('#add-to-cart--sticky').css('visibility', 'hidden');
    }, 410);
  }

  $(document).on('scroll', function () {
    if ($(document).scrollTop() > scrollHeight) {
      $('#add-to-cart--sticky').css('visibility', 'visible');
      setTimeout(function () {
        $('#add-to-cart--sticky').addClass('visible');
      }, 20);
    } else {
      $('#add-to-cart--sticky').removeClass('visible');
      setTimeout(function () {
        $('#add-to-cart--sticky').css('visibility', 'hidden');
      }, 410);
    }
  });
}
"use strict";

jQuery(document).ready(function () {
  jQuery("a[href='/apps/iwish']").click(function (e) {
    if (typeof Storage !== "undefined") {
      e.preventDefault();
      iWishPost('/apps/iwish', { iwishlist: JSON.stringify(iWishlistmain), cId: iwish_cid });
    }
  });
  jQuery(".iWishAdd").click(function () {
    var iWishvId = jQuery(this).parents(iwishWrapperClass).find(iWishVarSelector).val();
    iwish_add(jQuery(this), iWishvId);
    return false;
  });
  jQuery(".iWishAddColl").click(function () {
    var iWishvId = jQuery(this).attr("data-variant");
    iwish_addCollection(jQuery(this), iWishvId);
    return false;
  });
  iwishCheckColl();

  $('.iwishMsgInfo').html('Aucun produit');
  $('.shareTitle').html('<p>Email / Partager votre wishlist</p>');
});

function iwishCheckColl() {
  if (jQuery(".iwishcheck").length > 0) {
    jQuery(".iwishcheck").each(function () {
      var iWishvId = jQuery(this).attr("data-variant");
      var iWishpId = jQuery(this).attr("data-product");
      /*
      if (isInWishlist(iWishpId, iWishvId)) {
        jQuery(this).addClass("iwishAdded").html(iwish_added_txt_col);
      }
        */

      jQuery(this).removeClass("iwishcheck");
    });
  }
}
"use strict";
'use strict';

$('.order--container').on('click', function () {
  if ($(this).hasClass('follow__link') == false) {
    var orderId = $(this).attr('order-id');
    $('.order__details[order-id="' + orderId + '"]').slideToggle(200).toggleClass('is-active');
    $(this).toggleClass('child-active');
    $(this).children('.open__line__items--link').children().toggleClass('arrow--top arrow--bottom');
  }
});
'use strict';

var announcementDetails = {};
if ($('[announcement-details]').html()) {
  announcementDetails = JSON.parse($('[announcement-details]').html());
}

var text_ecran = announcementDetails.text_ecran;
var text_mobile = announcementDetails.text_mobile;
var lien_ecran = announcementDetails.lien_ecran;
var lien_mobile = announcementDetails.lien_mobile;
var counter = 1;
var elem = $("#annonce");

if (window.matchMedia("(min-width: 767px)").matches) {
  var change = function change() {
    if (text_ecran && text_ecran.length > 1) {
      elem.fadeOut(function () {
        elem.html(text_ecran[counter]);
        if (lien_ecran[counter] != "unlink") {
          elem.attr("href", lien_ecran[counter]);
        } else {
          elem.removeAttr('href');
        }
        counter++;
        if (counter >= text_ecran.length) {
          counter = 0;
        }
        elem.fadeIn();
      });
    }
  };

  if (lien_ecran && lien_ecran[0] && lien_ecran[0] != "unlink") {
    elem.attr("href", lien_ecran[0]);
  } else {
    elem.removeAttr('href');
  }
  setInterval(change, 6000);
} else {
  if (window.location.href.indexOf('products') == -1) {
    var _change = function _change() {
      if (text_mobile && text_mobile.length > 1) {
        elem.fadeOut(function () {
          elem.html(text_mobile[counter]);
          if (lien_mobile[counter] != "unlink") {
            elem.attr("href", lien_mobile[counter]);
          } else {
            elem.removeAttr('href');
          }
          counter++;
          if (counter >= text_mobile.length) {
            counter = 0;
          }
          elem.fadeIn();
        });
      }
    };

    if (lien_mobile && lien_mobile[0] && lien_mobile[0] != "unlink") {
      elem.attr("href", lien_mobile[0]);
    } else {
      elem.removeAttr('href');
    }
    text_mobile ? elem.html(text_mobile[0]) : null;
    setInterval(_change, 3000);
  }
}
'use strict';

$('.bulle__app__stocks--link-container').on('click', function () {
  var productId = $(this).attr('product-id');
  $('.bulle__app__stocks--link-container').removeClass('is__active');
  $('.bulle__app__stocks--link').removeClass('is__active');
  $(this).addClass('is__active');
  $(this).children('.bulle__app__stocks--link').addClass('is__active');
  $('#product__id--stock').val(productId);
});

$('.bulle__custom--value-stock').on('click', function () {
  var value = $(this).text();
  var option = $(this).attr('for');
  $('.bulle__custom--value-stock[for="' + option + '"]').removeClass('is__active');
  $(this).addClass('is__active');
  $('#product__taille--stock').val(value);
});

// Code de l'app
var shopId = 1;
var productId = $('#product__id--stock').val();
var productSize = $('#product__taille--stock').val();

var boutiques = [["boutique-1", "Boutique Marais", "104 Rue Vieille du Temple", "75003 Paris", "Tel: 09 73 66 30 42", "https://cdn.shopify.com/s/files/1/0306/9801/2807/files/agencement-boutique-surmesure-soi-paris-hopfab-1-740-x-496_22ed3b0d-6da8-435d-9e60-7ed26d05ee68_250x.png"], ["boutique-3", "Boutique Batignolles", "100 rue Legendre", "75017 Paris", "Tel: 01 42 64 55 51", "https://cdn.shopify.com/s/files/1/0306/9801/2807/files/NOS_ADRESSES_BATIGNOLLES_4_300x.progressive.jpg?v=1670339309"]];

// Check availability
$('#check__availability').on('click', function () {
  var $this = $(this);
  $('#content--availability').hide();
  $('#loader--availability').show();
  $this.attr('id', '');
  productId = $('#product__id--stock').val();
  productSize = $('#product__taille--stock').val();

  var data = {
    "productId": productId,
    "productSize": productSize
  };

  $.ajax({
    type: 'POST',
    url: 'https://soi-stocks.vercel.app/get-stocks',
    data: data,
    dataType: 'json',
    success: function success(data) {
      data.inventoryLevels.splice(1, 1);
      var boutiquesContent = '';
      for (var i = 0; i < boutiques.length; i++) {
        var button = "";
        if (data.inventoryLevels[i] && data.inventoryLevels[i][1] == true) {
          button = '<button style="margin-bottom: 20px;margin-top: 10px;" class="book__product btn button--container-footer"  shop-id="' + (i + 1) + '"> <span class="button__plain--black body__text--button-small fw--700 white text__uppercase" style="min-height:30px;" >R\xE9server pour 24h</span> </button>';
        } else {
          button = '<button style="margin-bottom: 20px;margin-top: 10px;" class="btn button--container-footer" > <span class="button__plain--black button__plain--primary__color--disabled body__text--button-small fw--700 white text__uppercase" style="min-height:30px;" >Indisponible</span> </button>';
        }

        boutiquesContent = boutiquesContent + ('\n          <div class="flex flex__direction--row justify__content--flex-start align__items--flex-start">\n            <img style="width: 100px;margin-right: 20px;" src="' + boutiques[i][5] + '" alt="" />\n            <div>\n              <p class="text__left body__text dark__color" style="line-height:20px;">\n                <strong>' + boutiques[i][1] + '</strong><br>\n                ' + boutiques[i][2] + '<br>\n                ' + boutiques[i][3] + '<br>\n                ' + boutiques[i][4] + '<br>\n                </p>\n                ' + button + '\n            </div>\n          </div>');
      }
      $('#data__stocks--container-body').html(boutiquesContent);
      $('#select__variable--container').hide();
      $('#data__stocks--container').fadeIn(300);
      $('#content--availability').show();
      $('#loader--availability').hide();
      $this.attr('id', 'check__availability');
    }
  });
});

// Book product
$('#book__clothes-link').on('click', function () {
  var validate = true;
  var $this = $(this);
  var customerName = $('#name--customer').val();
  var customerEmail = $('#email--customer').val();
  var emailRegex = new RegExp('[^@]+@[^\.]+\..+');
  var customerPhone = $('#phone--customer').val();

  if (customerName == "") {
    $('#error--name-customer').text('Ne peut pas être vide');
    validate = false;
  }

  if (customerEmail == "") {
    $('#error--email-customer').text('Ne peut pas être vide');
    validate = false;
  } else if (customerEmail.match(/[^@]+@[^\.]+\..+/) == null) {
    $('#error--email-customer').text('Doit respecter le format email');
    validate = false;
  }

  if (customerPhone == "") {
    $('#error--phone-customer').text('Ne peut pas être vide');
    validate = false;
  } else if (customerPhone.match(/^(\+33[1-9][0-9]{8})$|^([0-9]{10})$/) == null) {
    $('#error--phone-customer').text('Doit respecter le format de téléphone');
    validate = false;
  }

  var data = {
    "customerName": customerName,
    "customerEmail": customerEmail,
    "customerPhone": customerPhone,
    "comment": $('#comment--customer').val(),
    "shop": shopId,
    "productId": productId,
    "productSize": productSize
  };

  if (validate == true) {
    $this.attr('id', '');
    $('#content--booking').hide();
    $('#loader--booking').show();

    $.ajax({
      type: 'POST',
      url: 'https://soi-stocks.vercel.app/book-clothe',
      data: data,
      dataType: 'json',
      success: function success(data) {
        if (data.status == "success") {
          $('#form__book--container').hide();
          $('#success-container').fadeIn(300);
          $this.attr('id', 'book__clothes-link');
          $('#content--booking').show();
          $('#loader--booking').hide();
        }
      },
      error: function error(err) {
        $this.attr('id', 'book__clothes-link');
        $('#content--booking').show();
        $('#loader--booking').hide();
      }
    });
  }
});

// Divers
$('body').on('click', '#return__initialize', function (e) {
  $('#data__stocks--container').hide();
  $('#select__variable--container').fadeIn(300);
});
$('body').on('click', '#return__stock', function (e) {
  $('#form__book--container').hide();
  $('#data__stocks--container').fadeIn(300);
});

$('.close--book-app').on('click', function () {
  $('.stocks__app--container').hide();
});

$('body').on('click', '.book__product', function (e) {
  shopId = $(this).attr('shop-id');
  $('#data__stocks--container').hide();
  $('#form__book--container').fadeIn(300);
});

$('#check__availability--link').on('click', function () {
  $('#stocks__app--container').css('display', 'flex');
  $('#page__overlay--white').addClass('opened');
  $('#page__overlay--white').attr('for', 'app-stock');
});

$('body').on('click', '#page__overlay--white', function (e) {
  var attrFor = $(this).attr('for');
  if (attrFor == "app-stock") {
    closeApp();
  }
});

$('.close').on('click', function (e) {
  closeApp();
});

$('.close--book-app').on('click', function (e) {
  closeApp();
});

$('.input--form').on('focus', function () {
  var attribute = $(this).attr('name');
  $('.error[name="' + attribute + '"]').text('');
});

function closeApp() {
  $('#stocks__app--container').css('display', 'none');
  $('#page__overlay--white').removeClass('opened');
  $('#data__stocks--container, #success-container, #form__book--container, #error-container').hide();
  $('#select__variable--container').show();
}
'use strict';

if (window.matchMedia("(min-width: 1100px)").matches) {
  $('.button__action--cart-preview').mouseenter(function (e) {
    $('#cart__preview').addClass('opened');
    $('.icon--sac-boutique-wisp').removeClass('white');
    handleNavbarHover("opened");
  });

  $('.button__action--cart-preview').on('click', function () {
    window.location.replace('/cart');
  });

  $('#cart__preview').mouseenter(function (e) {
    $('#cart__preview').addClass('opened');
    handleNavbarHover("opened");
  });

  $('#cart__preview').mouseleave(function (e) {
    $('#cart__preview').removeClass('opened');
    $('#cart__preview').removeClass('opened--added-to-cart');

    $('.link--text-style--cart').removeClass('link__active');
    if ($(e.relatedTarget).is('.link--text-style')) {} else {
      handleNavbarHover("closed");
    }
  });

  $('.button__action--cart-preview').mouseleave(function (e) {
    $('#cart__preview').removeClass('opened');
    $('#cart__preview').removeClass('opened--added-to-cart');

    $('.link--text-style--cart').removeClass('link__active');
    if ($(e.relatedTarget).is('.links__container--half, #navigation__links--list, .link--text-style, .announcement__bar--container')) {} else {
      handleNavbarHover("closed");
    }
  });
}
if (window.matchMedia("(max-width: 1100px)").matches) {
  if (window.location.pathname != "/cart") {
    $('.button__action--cart-preview').on('click', function () {
      window.location.replace('/cart');
    });
  }
}

if (window.matchMedia("(max-width: 767px)").matches && window.location.href.indexOf('products') > -1) {
  // Case for product page mobile
  $("#cart__preview").css({ 'top': '50px' });
  $("#cart__preview--container").css({ 'margin-top': '0px' });
} else {
  if ($(document).scrollTop() > 20) {
    $("#cart__preview").css('top', '35px');
  }
}

$(document).on('scroll', function () {
  if (window.matchMedia("(max-width: 767px)").matches && window.location.href.indexOf('products') > -1) {
    // Case for product page mobile
    $("#cart__preview").css({ 'top': '50px' });
    $("#cart__preview--container").css({ 'margin-top': '0px' });
  } else {
    if ($(document).scrollTop() > 20) {
      $("#cart__preview").css('top', '35px');
    } else {
      $("#cart__preview").css('top', '70px');
    }
  }
});

function handleNavbarHover(status) {
  if (window.location.pathname == "/") {
    if (window.matchMedia("(min-width: 1101px)").matches) {
      if (status == "opened") {
        $('.link--text-style--cart').addClass('link__active');
        $('#navigation--container').removeClass('transparent--nav');
        $('#main__logo--svg').removeClass('logo--white');
        $('#icon-search .icon--search').removeClass('logo--white');
        $('.icon--sac-boutique-wisp').removeClass('white');
      } else {
        //$('#navigation--container').addClass('transparent--nav');
        $('#main__logo--svg').addClass('logo--white');
        //$('#icon-search .icon--search').addClass('logo--white');
      }
    }
  }
}
'use strict';

$('.picto__container').on('click', function () {
  var number = $(this).attr('data-separator');
  $('.picto__container').removeClass('is-active');
  $(this).addClass('is-active');
  $('.questions__container.is-opened').removeClass('is-opened is-visible');
  $('.questions__container[data-separator=' + number + ']').addClass('is-opened');
  setTimeout(function () {
    $('.questions__container[data-separator=' + number + ']').addClass('is-visible');
  }, 10);
});
'use strict';

var navigationFooterActive = undefined;
function initNavigationFooter() {
  if (window.matchMedia("(max-width: 767px)").matches && navigationFooterActive == undefined) {
    $('#sidebar-accordion-footer .plus__icon').show();
    $('#sidebar-accordion-footer').find('li.extend').click(function (e) {
      $(this).children('.extended-submenu').slideToggle('fast');
      $(this).children('.nav__footer--title').children('.plus__icon').toggleClass('opened');
      $(this).toggleClass('active');
    });
    navigationFooterActive = 1;
  } else if (window.matchMedia("(min-width: 768px)").matches && navigationFooterActive != undefined) {

    $('#sidebar-accordion-footer').find('li.extend').off('click');
    $('#sidebar-accordion-footer .extended-submenu').show();
    $('#sidebar-accordion-footer .plus__icon').hide();
    navigationFooterActive = undefined;
  }
}
initNavigationFooter();

$(window).on('resize', function () {
  initNavigationFooter();
});
"use strict";

$(".emballage--button").on("click", function () {
  var buttonFor = $(this).attr('for');
  var data = { updates: {} };
  data.updates[32742629081223] = 0;
  data.updates[36992666730662] = 0;
  if (buttonFor == "gift") {
    data.updates[32742629081223] = 1;
  } else {
    data.updates[36992666730662] = 1;
  }

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function success(e) {
      renderCart();
    },
    error: function error(e) {
    }
  });
});
"use strict";

function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

/*if (getCookie('show-modal-newsletter') == 'yes') {
} else {
  setTimeout(function(){
    if (parseInt(getCookie('visited')) >= 2 ) {
      $('#modal-cart-page-overlay').show().css('display','flex');
      var CookieDate = new Date;
      CookieDate.setMonth(CookieDate.getMonth() + 8);
      document.cookie = "show-modal-newsletter=yes; expires=" + CookieDate.toGMTString() + "; path=/";
    }
    }, 4000);
}*/

$('#close-modal-cart').on('click', function () {
  $('#modal-cart-page-overlay').hide();
});
$(document).mouseup(function (e) {
  var container = $("#modal-cart-page");

  // if the target of the click isn't the container nor a descendant of the container
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('#modal-cart-page-overlay').hide();
  }
});

if (!getCookie('visited')) {
  var CookieDateVisited = new Date();
  CookieDateVisited.setDate(CookieDateVisited.getDate() + 7);
  document.cookie = "visited=0; expires=" + CookieDateVisited.toGMTString() + "; path=/";
} else {
  var visited = parseInt(getCookie('visited')); // visited = 0
  visited++; // increase counter of visits
  var CookieDateVisitedUpdate = new Date();
  CookieDateVisitedUpdate.setDate(CookieDateVisitedUpdate.getDate() + 7);
  document.cookie = "visited=" + visited + "; expires=" + CookieDateVisitedUpdate.toGMTString() + "; path=/";
}
'use strict';

$('#close-article-page').on('click touchend', function () {
  $('#article-page-overlay').hide();
});
$(document).mouseup(function (e) {
  var container = $("#article-page");
  // if the target of the click isn't the container nor a descendant of the container
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('#article-page-overlay').hide();
  }
});
$('.article').on('click touchend', function () {
  var background_url = "https:" + $(this).attr('background-img');
  $('#click-contain img').attr('src', background_url);
  $('#article-page-overlay').show().css('display', 'flex');
});
'use strict';

var galleryTop = new Swiper('#swiper__product', {
  zoom: {
    maxRatio: 2
  },
  effect: 'fade',
  fade: { crossFade: true },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true
  },
  loop: true,
  on: {
    click: function click(e) {

      if (galleryTop.zoom.scale == 1) {
        $('.swiper-zoom-container').css('cursor', 'crosshair');

        galleryTop.zoom.in();
      } else {
        $('.swiper-zoom-container').css('cursor', 'zoom-in');

        galleryTop.zoom.out();
      }
    },
    slideChangeTransitionStart: function slideChangeTransitionStart(event) {
      if ($('.swiper-slide-active').find('#video-slider-product').length > 0) {
        $('.video-product-gallery--container').show();
      } else {
        $('.video-product-gallery--container').hide();
      }
      var slideNumber = $('.swiper-slide-active .product__image').attr('slide-number');
      $('#swiper__product__thumb .thumb--element').removeClass('active__slide');
      $('#swiper__product__thumb .thumb--element[data-slider="' + slideNumber + '"]').addClass('active__slide');
    }
  }
});

if (window.product && window.productGallery && window.productGallery.zoom == false && window.location.pathname != "/products/gift-card") {
  galleryTop.zoom.disable();
}

//galleryTop.zoom.init()


/*window.sliderProduct = galleryTop;
var swiperSlide = document.getElementsByClassName('swiper-zoom-container')
 if (window.matchMedia("(min-width: 768px)").matches) {
  for(var index = 0; index<swiperSlide.length; index++){
    swiperSlide[index].addEventListener('click',function(e){
      if (window.sliderProduct.zoom.scale == 1) {
        window.sliderProduct.zoom.in();
        $('.swiper-zoom-container').css('cursor', 'crosshair');
      }
    })
    swiperSlide[index].addEventListener('mouseout',function(e){
      window.sliderProduct.zoom.out();
      $('.swiper-zoom-container').css('cursor', 'zoom-in');
    })
  }
} else {
   var tapped=false
  $("#mini-cart .dropdown-toggle").on("touchstart",function(e){
  if(!tapped){ //if tap is not set, set up single tap
    tapped = setTimeout(function(){
    tapped=null
    },300);
  } else {
    clearTimeout(tapped);
    tapped=null
    if (window.sliderProduct.zoom.scale == 1) {
      window.sliderProduct.zoom.in();
    } else {
      window.sliderProduct.zoom.out();
    }
  }
  e.preventDefault()
  });
}*/

$('.thumb--change').on('click', function () {

  var thumbHeight = $('.thumb--element').height();
  var thumbAction = $(this).is('.thumb--prev') ? 'prev' : 'next';
  var currentSlide = parseInt($('.thumb--element.active__slide').attr('data-slider'));
  var maxSlides = $('.thumb--element.thumb--element-last').attr('data-slider');

  if (thumbAction == 'next') {
    if (currentSlide == maxSlides) {} else {
      if (currentSlide + 1 >= 3) {
        $('.swiper__product__thumb--container').animate({
          scrollTop: (currentSlide - 1) * thumbHeight
        }, 500);
      }
      $('.thumb--element.active__slide').removeClass('active__slide');
      $('.thumb--element[data-slider=' + (currentSlide + 1) + ']').addClass('active__slide');
      galleryTop.slideTo(currentSlide + 1, 300);
    }
  } else {
    if (currentSlide == 1) {} else {
      $('.swiper__product__thumb--container').animate({
        scrollTop: Math.max((currentSlide - 3) * thumbHeight, 0)
      }, 500);
      $('.thumb--element.active__slide').removeClass('active__slide');
      $('.thumb--element[data-slider=' + (currentSlide - 1) + ']').addClass('active__slide');
      galleryTop.slideTo(currentSlide - 1, 300);
    }
  }
});

$('.thumb--element').click(function () {
  var thumbHeight = $('.thumb--element').height();
  var data_slider = $(this).attr('data-slider');

  if (data_slider >= 2) {
    $('.swiper__product__thumb--container').animate({
      scrollTop: (data_slider - 2) * thumbHeight
    }, 500);
  }
  $('.thumb--element.active__slide').not(this).toggleClass('active__slide');
  $(this).addClass('active__slide');
  galleryTop.slideTo(data_slider, 300);
});

document.addEventListener('optionChanged', function (elem) {
  var rankImage = $('.list__option--item.selected__option').attr('data-slider');
  galleryTop.slideTo(rankImage);
  $('.swiper-slide.thumb--element').removeClass('active__slide');
  $('.swiper-slide.thumb--element[data-slider="' + rankImage + '"]').addClass('active__slide');
}, false);

if ($('.list__option--item.selected__option').length > 0) {
  var data_slider = $('.list__option--item.selected__option').attr('data-slider');
  galleryTop.slideTo(data_slider);
  $('.swiper-slide.thumb--element').removeClass('active__slide');
  $('.swiper-slide.thumb--element[data-slider="' + data_slider + '"]').addClass('active__slide');
}
'use strict';

var productListSwiper = new Swiper('#swiper-container-featured-collection', {
  // direction: 'horizontal',
  loop: true,
  navigation: {
    nextEl: '#swiper-next-top-grey',
    prevEl: '#swiper-prev-top-grey'
  },
  slidesPerView: 4,
  spaceBetween: 30,
  autoplay: false,
  initialSlide: 1,
  breakpoints: {
    1250: {
      spaceBetween: 20
    },
    1000: {
      slidesPerView: 3,
      spaceBetween: 15
    },
    600: {
      slidesPerView: 2,
      spaceBetween: 15
    },
    599: {
      slidesPerView: 'auto',
      // À activer si on veut laisser le scroll libre
      freeMode: true,
      spaceBetween: 15
    }
  },
  speed: 600
});
'use strict';

$('.go--back').on('click', function () {
  if (document.referrer.indexOf(window.location.hostname) > -1 && document.referrer.includes('/collection')) {
    window.history.back();
  } else if (document.referrer.indexOf(window.location.hostname) > -1) {
    window.history.back();
  } else if (this.getAttribute("link") != '') {
    window.location = $(this).attr('link');
  } else {
    window.location = 'https://www.suiparis.com/';
  }
});

// Shipping Tabs
$('.shipping--nav-tabs li').click(function () {
  var tab_id = $(this).attr('data-index');
  $('.shipping--nav-tabs li').removeClass('active');
  $('.shipping--description-item').removeClass('active');
  $(this).addClass('active');
  $('.shipping--description').find('[data-index=\'' + tab_id + '\']').addClass('active');
});

if (window.matchMedia("(max-width: 767px)").matches) {
  if (window.location.href.indexOf("product") > -1) {
    if ($(document).scrollTop() > 20) {
      $('.add__to__cart--container').addClass('opened');
    } else {
      $('.add__to__cart--container').removeClass('opened');
    }
    $(document).on('scroll', function () {
      if ($(document).scrollTop() > 20) {
        $('.add__to__cart--container').addClass('opened');
      } else {
        $('.add__to__cart--container').removeClass('opened');
      }
    });
  }
}
"use strict";

function getCookieProtected(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

function putCookieProtected() {
  var CookieDate = new Date();
  CookieDate.setMonth(CookieDate.getMonth() + 12);
  document.cookie = "password-accepted=yes; expires=" + CookieDate.toGMTString() + "; path=/";
}

$('#newsletter-protected').submit(function () {
  putCookieProtected();
  return true;
});

if (getCookieProtected('password-accepted') == undefined) {
  $('#protected__page--container').show();
} else {
  $('#MainContent, #oin-us-insta, #instagram-feed').show();
}
// var selectedInput = $(`.select__custom--value[value="{{ collection.sort_by | default: collection.default_sort_by | escape }}"]`).text();
// $(`.select__custom--value[value="{{ collection.sort_by | default: collection.default_sort_by | escape }}"]`).addClass('is__active')
// $('.select__custom--selected-value').text(selectedInput)

// $('#sort-by-custom')
// .val('{{ collection.sort_by | default: collection.default_sort_by | escape }}')
"use strict";
'use strict';

setTimeout(function () {
  var mySwiper = new Swiper('.swiper-container-back-image', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    speed: 600
  });

  // details-finitions.liquid
  var swiper__details = new Swiper('#swiper__image--details', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '#swiper-next-top-grey-product-right2',
      prevEl: '#swiper-prev-top-grey-product-left2'
    }
  });

  if (window.matchMedia("(max-width: 767px)").matches) {
    var swiperLookMobile = new Swiper('#produits__du__look--container.slider--mobile', {
      direction: 'horizontal',
      loop: true,
      slidesPerView: 2,
      spaceBetween: 20,
      lazy: false,
      navigation: {
        nextEl: '#swiper-next-look',
        prevEl: '#swiper-prev-look'
      },
      breakpoints: {
        750: {
          spaceBetween: 10
        },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        }
      }
    });
  }

  // Matiere.liquid
  var swiperMatiere = undefined;
  function initSwiperMatiere() {
    var screenWidth = $(window).width();
    if (window.matchMedia("(max-width: 650px)").matches && swiperMatiere == undefined) {
      swiperMatiere = new Swiper('#swiper__marketings__claims', {
        direction: 'horizontal',
        loop: true,
        slidesPerView: 2,
        slidesPerGroup: 2,
        speed: 600
      });
    }
  }

  //Swiper plugin initialization
  initSwiperMatiere();

  //Swiper plugin initialization on window resize
  $(window).on('resize', function () {
    initSwiperMatiere();
  });

  $(document).ready(function () {
    // bandeau-footer.liquid
    var mySwiperFooter = undefined;
    function initSwiperBandeau() {
      var screenWidth = $(window).width();
      if (window.matchMedia("(max-width: 949px)").matches && mySwiperFooter == undefined) {
        mySwiperFooter = new Swiper('.swiper-container-footer', {
          direction: 'horizontal',
          loop: true,
          slidesPerView: 4,
          breakpoints: {
            950: {
              slidesPerView: 2
            },
            580: {
              slidesPerView: 1
            }
          },
          pagination: {
            el: '#swiper__pagination-bandeau-footer',
            clickable: true
          }

        });
      } else if (window.matchMedia("(min-width: 950px)").matches && mySwiperFooter != undefined) {
        mySwiperFooter.destroy();
        mySwiperFooter = undefined;
      }
    }

    $(window).on('resize', function () {
      initSwiperBandeau();
    });

    //Swiper plugin initialization
    initSwiperBandeau();
  });

  // header-navbar--collection
  var navigationCollection = undefined;
  function initNavigationCollection() {
    if (window.matchMedia("(max-width: 767px)").matches && navigationCollection == undefined) {
      $('.navbar--collection .arrow').show();
      $('.navbar--collection').find('div.extend').click(function (e) {
        $(this).children('.extended-submenu').slideToggle('fast');
        $(this).children('.nav__collection--title').children('.arrow').toggleClass('arrow-top').toggleClass('arrow-bottom');
        $(this).toggleClass('active');
      });
      navigationCollection = 1;
    } else if (window.matchMedia("(min-width: 768px)").matches && navigationCollection != undefined) {
      $('.navbar--collection').find('div.extend').off('click');
      $('.navbar--collection .plus__icon').hide();
      navigationCollection = undefined;
    }
  }
  initNavigationCollection();

  $(window).on('resize', function () {
    initNavigationCollection();
  });

  // boutique--homepage.liquid
  var swiper__boutique = new Swiper('#swiper__image--boutique', {
    direction: 'horizontal',
    loop: false,
    effect: 'fade',
    speed: 300,
    slidesPerView: 1,
    navigation: {
      nextEl: '#swiper-next-top-product-right2',
      prevEl: '#swiper-prev-top-product-left2'
    }
  });
  var swiper__boutique2 = new Swiper('#swiper__image--boutique2', {
    direction: 'horizontal',
    loop: false,
    effect: 'fade',
    speed: 300,
    slidesPerView: 1,
    navigation: {
      nextEl: '#swiper-next-top-product-right2',
      prevEl: '#swiper-prev-top-product-left2'
    }
  });
  swiper__boutique.on('slideChange', function () {
    swiper__boutique2.slideTo(swiper__boutique.activeIndex, 300);
  });
  swiper__boutique2.on('slideChange', function () {
    swiper__boutique.slideTo(swiper__boutique2.activeIndex, 300);
  });

  // product-list-product-page.liquid
  var swiper__404 = new Swiper('#swiper-container-featured-collection', {
    // direction: 'horizontal',
    loop: true,
    navigation: {
      nextEl: '#swiper-next-top-grey',
      prevEl: '#swiper-prev-top-grey'
    },
    slidesPerView: 4,
    spaceBetween: 30,
    autoplay: false,
    initialSlide: 1,
    breakpoints: {
      1250: {
        spaceBetween: 20
      },
      1000: {
        slidesPerView: 3,
        spaceBetween: 15
      },
      600: {
        slidesPerView: 2,
        spaceBetween: 15
      },
      599: {
        slidesPerView: 'auto',
        // À activer si on veut laisser le scroll libre
        freeMode: true,
        loop: false,
        spaceBetween: 15
      }
    },
    speed: 600
  });

  var boutiqueIndex = {};
  if ($('[boutique-index]').html()) {
    boutiqueIndex = JSON.parse($('[boutique-index]').html());
  }
  // boutique.liquid
  for (i = 0; i <= boutiqueIndex.forloopIndex; i++) {
    var swiper__boutique = new Swiper('#swiper__image--boutique-' + i, {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      navigation: {
        nextEl: '#swiper-next-top-white-product-right2-' + i,
        prevEl: '#swiper-prev-top-white-product-left2-' + i
      }
    });
  }

  // image-background-slider--homepage.liquid
  var swiperBackgroundHome = new Swiper('.swiper-container-back-image', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination--home',
      type: 'bullets',
      clickable: true
    },
    speed: 600
  });

  // instagram-feed.js
  var instaFeed = new Swiper('.swiper-container-isntagram-feed', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 5,
    autoplay: false,
    spaceBetween: 5,
    navigation: {
      nextEl: '#swiper-next-top-white-instagram',
      prevEl: '#swiper-prev-top-white-instagram'
    },
    breakpoints: {
      650: {
        slidesPerView: 2
      },
      900: {
        slidesPerView: 3
      },
      1100: {
        slidesPerView: 4
      }
    },
    speed: 600
  });

  // slider-moiensoi.liquid
  var moiEnSoi = new Swiper('.swiper-container-moiensoi', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 4,
    autoplay: false,
    spaceBetween: 10,
    navigation: {
      nextEl: '#swiper-next-top-white-instagram',
      prevEl: '#swiper-prev-top-white-instagram'
    },
    breakpoints: {
      700: {
        slidesPerView: 2
      },
      1050: {
        slidesPerView: 3
      }
    },
    speed: 600
  });

  // triple-slider--homepage.js

  var tripleSlider1 = new Swiper('.swiper-container-background-image', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    autoplay: 'false',
    speed: 600,
    effect: 'fade'
  });
  var tripleSlider2 = new Swiper('.swiper-container-icone', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    autoplay: 'false',
    speed: 600,
    effect: 'fade'
  });
  var tripleSlider3 = new Swiper('.swiper-container-content', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    autoplay: 'false',
    navigation: {
      nextEl: '#swiper-next-top-content',
      prevEl: '#swiper-prev-top-content'
    },
    speed: 600

  });
  tripleSlider3.on('slideNextTransitionStart', function () {
    tripleSlider2.slideNext();
    tripleSlider1.slideNext();
  });

  tripleSlider3.on('slidePrevTransitionStart', function () {
    tripleSlider2.slidePrev();
    tripleSlider1.slidePrev();
  });
}, 100);

var packaging = new Swiper('.packaging-container .swiper', {
  direction: 'horizontal',
  loop: true,
  slidesPerView: 3,
  autoplay: false,
  spaceBetween: 5,
  navigation: {
    nextEl: '#swiper-packaging-next',
    prevEl: '#swiper-packaging-prev'
  },
  breakpoints: {
    767: {
      slidesPerView: 2
    }
  },
  speed: 600
});
'use strict';

$('.site-header__section--switcher').on('click', function () {
  $('.wg-drop.country-selector .wgcurrent').toggleClass('rotate_arrow');
});
});

/* === MOBILE SWIPE COLLECTION CARDS - 2026-05-21 === */
(function () {
  function resizeShopifyImage(url, size) {
    var replaced = url.replace(/_(small|medium|large|grande|compact|original|\d+x\d*)(\.[a-z]+)/i, '_' + size + '$2');
    if (replaced !== url) return replaced;
    return url.replace(/(\.(webp|jpg|jpeg|png))(\?|$)/i, '_' + size + '$1$3');
  }
  function fetchImages(handle) {
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        return d.images
          .filter(function (s) { return s.indexOf('--paysage') === -1 && s.indexOf('videoproduct') === -1; })
          .map(function (s) { return resizeShopifyImage(s, '800x'); });
      });
  }
  function bindCard(card) {
    if (card.dataset.swipeBound) return;
    card.dataset.swipeBound = '1';
    var img = card.querySelector('.product__item__image');
    if (!img) return;
    var arrowSrc = card.querySelector('.grid__arrow--container');
    if (!arrowSrc) return;
    var handle = arrowSrc.getAttribute('handle');
    if (!handle) return;
    card.style.position = 'relative';
    var state = { index: 0, images: null, total: 0, preloaded: {} };
    var dotsEl = null;
    function showImage(i) {
      if (!state.images || !state.images[i]) return;
      var target = state.images[i];
      img.classList.remove('lazyload');
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.removeAttribute('srcset');
      var sources = card.querySelectorAll('picture source');
      sources.forEach(function (s) {
        s.removeAttribute('data-srcset');
        s.setAttribute('srcset', target);
      });
      img.src = target;
      state.index = i;
      updateDots();
    }
    function gotoOffset(d) {
      if (!state.total) return;
      var n = (state.index + d + state.total) % state.total;
      showImage(n);
    }
    function buildDots() {
      if (dotsEl) { dotsEl.remove(); dotsEl = null; }
      if (state.total < 2) return;
      dotsEl = document.createElement('div');
      dotsEl.style.cssText = 'position:absolute;bottom:10px;left:0;right:0;display:flex;justify-content:center;gap:5px;z-index:5;pointer-events:none;';
      for (var i = 0; i < state.total; i++) {
        var dot = document.createElement('span');
        dot.style.cssText = 'width:6px;height:6px;border-radius:50%;background:rgba(255,255,255,.55);box-shadow:0 0 3px rgba(0,0,0,.6);transition:background .2s;';
        dotsEl.appendChild(dot);
      }
      card.appendChild(dotsEl);
      updateDots();
    }
    function updateDots() {
      if (!dotsEl) return;
      Array.prototype.forEach.call(dotsEl.children, function (d, i) {
        d.style.background = i === state.index ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,.5)';
      });
    }
    function preloadFrom(startIdx) {
      if (!state.images) return;
      for (var i = startIdx; i < state.images.length; i++) {
        if (state.preloaded[i]) continue;
        var p = new Image();
        p.src = state.images[i];
        state.preloaded[i] = true;
      }
    }
    function ensureImages(depth) {
      if (state.images) {
        if (depth === 'all') preloadFrom(2);
        return Promise.resolve();
      }
      return fetchImages(handle).then(function (imgs) {
        state.images = imgs;
        state.total = imgs.length;
        buildDots();
        preloadFrom(1);
        if (depth === 'all') preloadFrom(2);
      }).catch(function () {});
    }
    var startX = 0, startY = 0, startT = 0;
    card.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      startX = t.clientX; startY = t.clientY; startT = Date.now();
      ensureImages('all');
    }, { passive: true });
    card.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0];
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      var dt = Date.now() - startT;
      if (dt > 700) return;
      if (Math.abs(dx) < 40) return;
      if (Math.abs(dx) < Math.abs(dy) * 1.3) return;
      var link = card.closest('a');
      if (link) {
        var blocker = function (ev) { ev.preventDefault(); ev.stopImmediatePropagation(); };
        link.addEventListener('click', blocker, true);
        setTimeout(function () {
          try { link.removeEventListener('click', blocker, true); } catch (err) {}
        }, 500);
      }
      ensureImages().then(function () {
        if (!state.total) return;
        gotoOffset(dx < 0 ? 1 : -1);
      });
    }, { passive: true });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            ensureImages();
            io.disconnect();
          }
        });
      }, { rootMargin: '200px' });
      io.observe(card);
    }
  }
  function init() {
    if (window.matchMedia('(min-width: 750px)').matches) return;
    var cards = document.querySelectorAll('.product__item__image--container');
    cards.forEach(bindCard);
    if (!window._swipeMo) {
      window._swipeMo = new MutationObserver(function () {
        var newCards = document.querySelectorAll('.product__item__image--container:not([data-swipe-bound])');
        newCards.forEach(bindCard);
      });
      window._swipeMo.observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();
/* === FIN MOBILE SWIPE === */